import React, { Component } from "react";
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
import Footer from "../../Component/Footer";
import Header from "../../Component/Header";
import Menu from "../../Component/Menu";
import moment from "moment";
import SalesServices from "../SalesServices";
import {
  address,
  address2,
  ccity,
  ccountry,
  clientname,
  companyemail,
  contactnumber,
  cstate,
  currency,
  currentTenant,
  czip,
  gstin,
  pan,
  logo,
  prefix1,
  thousandsdisplay,
  userid,
} from "../../Common/Credentials";
import { spin } from "../../Common/NewLoader";
// import UserService from "../../users/UserService";
import { salesid } from "../../Common/Permissions";
import downloadfiles from "../../Common/upload/downloadfiles";
// import PropTypes from 'prop-types';
import {
  Box,
  Collapse,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  FormLabel,
  Paper,
  Chip,
  Tooltip,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { NumericFormat } from "react-number-format";
import { Modal } from "react-bootstrap";
import UploadFilesService from "../../Common/upload/UploadFilesService";
import FileServices from "../../Common/upload/FileServices";

import { ToWords } from "to-words";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import SettingsServices from "../../Settings/SettingsServices";
import BankServices from "../../Masters/Bank/BankServices";
import Swal from "sweetalert2";

import { rupeeFormatter } from "../../Common/rupeeFormatter.jsx";

// import logo from '../../images/Finanzz.png'
import amiriFont from "../../fonts/Amiri/Amiri-Regular-base64.js";

import amiriBoldFont from "../../fonts/Amiri/Amiri-Bold-base64.js";
import Breadcrumb from "../../NewUI/NewComponents/Breadcrumb.jsx";

let curmonth, year, day, path;
let doctype;

class ViewQuotation extends Component {
  constructor(props) {
    super(props);
    const id = this.props.location.state.id;
    this.state = {
      Order: [],
      saleorderitems: [],
      serviceList: [],
      milestones: [],
      id: id,
      sostatus: "",
      status: "",
      stat: 0,
      message: "",
      loading: false,
      showModal: false,
      desc: "",
      poid: "",
      amount: "",
      selectedFiles: undefined,
      currentFile: undefined,
      progress: 0,
      isError: false,
      fileInfos: [],
      fileInfo: "",
      partyid: "",
      error: false,
      errorMessage: {},
      pofile: "",
      popath: "",
      filedata: "",
      path: "",
      templete: "",
      open: false,
      bankdetails: {},
      hovered: null,
      expandedRows: {},
      activeProductDetail: null,
      activeServiceDetail: null,
      activeMilestoneDetail: null,
    };
    this.handledownload = this.handledownload.bind(this);
    this.selectFile = this.selectFile.bind(this);
    this.upload = this.upload.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    // Add sidebar width to styles
    this.styles.sidebar = {
      width: '280px',
      borderRight: '1px solid #e2e8f0',
      backgroundColor: '#f8fafc',
      flexShrink: 0,
      padding: '0px',
      overflowY: 'auto',
      maxHeight: '600px',
    };

    this.styles.sidebarItem = {
      display: 'block',
      padding: '8px 12px',
      borderBottom: '1px solid #f1f5f9',
      textDecoration: 'none',
      color: '#4d4d4d',
      transition: 'background-color 0.03s ease',
      cursor: 'pointer',
      borderRadius: '4px',
      marginBottom: '4px',
    };

    this.styles.sidebarItemActive = {
      backgroundColor: '#dbeafe',
      borderRight: '3px solid #4d4d4d',
      color: '#4d4d4d',
      fontWeight: 500,
    };

    this.styles.sidebarItemName = {
      fontSize: '0.8rem',
      fontWeight: 500,
      marginBottom: '2px',
    };

    this.styles.sidebarItemDetails = {
      fontSize: '0.7rem',
      color: '#6b7280',
    };

    this.styles.detailContent = {
      flex: 1,
      padding: '16px',
      overflowY: 'auto',
    };

  }

  // Modern styles
  styles = {
    container: {
      backgroundColor: '#f8fafc',
      minHeight: '100vh',
      padding: '16px',
    },
    card: {
      backgroundColor: '#ffffff',
      borderRadius: '8px',
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
      border: '1px solid #e2e8f0',
      overflow: 'hidden',
    },
    header: {
      padding: '16px 20px',
      borderBottom: '1px solid #e2e8f0',
      backgroundColor: '#ffffff',
    },
    breadcrumb: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      fontSize: '0.8rem',
      color: '#64748b',
      marginBottom: '12px',
      listStyle: 'none',
      padding: 0,
      margin: 0,
    },
    breadcrumbItem: {
      color: '#64748b',
      textDecoration: 'none',
      transition: 'color 0.03s ease, transform 0.03s ease',
      display: 'inline-block',
    },
    breadcrumbActive: {
      color: '#1e293b',
      fontWeight: 500,
    },
    headerContent: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    title: {
      fontSize: '1.5rem',
      fontWeight: 600,
      color: '#1e293b',
      margin: 0,
    },
    subtitle: {
      margin: '4px 0 0 0',
      color: '#64748b',
      fontSize: '0.8rem',
    },
    headerActions: {
      display: 'flex',
      gap: '8px',
      alignItems: 'center',
    },
    btn: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px',
      padding: '6px 12px',
      borderRadius: '6px',
      border: 'none',
      fontSize: '0.8rem',
      fontWeight: 500,
      cursor: 'pointer',
      transition: 'all 0.03s ease',
      textDecoration: 'none',
    },
    btnPrimary: {
      backgroundColor: '#4d4d4d',
      color: '#ffffff',
    },
    btnOutline: {
      backgroundColor: '#ffffff',
      color: '#4d4d4d',
      border: '1px solid #4d4d4d',
    },
    btnDanger: {
      backgroundColor: '#ffffff',
      color: '#dc2626',
      border: '1px solid #dc2626',
    },
    hoveredBtnDanger: {
      backgroundColor: '#dc2626',
      color: '#ffffff',
      border: '1px solid #ffffff',
    },
    tableContainer: {
      overflow: 'auto',
      padding: '8px 0',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      fontSize: '0.8rem',
    },
    tableHeader: {
      backgroundColor: '#f8fafc',
      borderBottom: '2px solid #e2e8f0',
    },
    th: {
      padding: '10px 12px',
      textAlign: 'left',
      fontWeight: 600,
      color: '#1e293b',
      fontSize: '0.75rem',
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
    },
    tableRow: {
      borderBottom: '1px solid #f1f5f9',
      cursor: 'pointer',
      transition: 'all 0.03s ease',
      backgroundColor: '#ffffff',
    },
    tableRowHovered: {
      backgroundColor: '#f8fafc',
      transform: 'scale(1.01)',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
      transition: 'all 0.03s ease',
    },
    td: {
      padding: '12px',
      fontSize: '0.8rem',
      color: '#374151',
    },
    itemName: {
      fontWeight: 500,
      color: '#1e293b',
    },
    detailGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '16px',
      marginBottom: '24px',
    },
    detailSection: {
      backgroundColor: '#f8fafc',
      padding: '16px',
      borderRadius: '8px',
      border: '1px solid #e2e8f0',
    },
    sectionTitle: {
      fontSize: '0.9rem',
      fontWeight: 600,
      color: '#1e293b',
      marginBottom: '12px',
      paddingBottom: '8px',
      borderBottom: '1px solid #e2e8f0',
    },
    detailRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '8px 0',
      borderBottom: '1px solid #f1f5f9',
    },
    detailLabel: {
      fontSize: '0.75rem',
      color: '#64748b',
      fontWeight: 500,
    },
    detailValue: {
      fontSize: '0.8rem',
      color: '#1e293b',
      fontWeight: 500,
    },
    statusBadge: {
      padding: '4px 8px',
      borderRadius: '12px',
      fontSize: '0.7rem',
      fontWeight: 500,
      display: 'inline-block',
    },
    statusActive: {
      backgroundColor: '#d1fae5',
      color: '#065f46',
    },
    statusCompleted: {
      backgroundColor: '#dbeafe',
      color: '#1e40af',
    },
    statusCancelled: {
      backgroundColor: '#fee2e2',
      color: '#b91c1c',
    },
    actionButtons: {
      display: 'flex',
      gap: '8px',
      justifyContent: 'center',
    },
    loadingContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '200px',
      color: '#64748b',
    },
    detailView: {
      backgroundColor: '#f8fafc',
      padding: '16px',
      borderRadius: '8px',
      border: '1px solid #e2e8f0',
      marginBottom: '16px',
    },
    detailViewHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '16px',
      paddingBottom: '12px',
      borderBottom: '1px solid #e2e8f0',
    },
    backButton: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      padding: '6px 12px',
      backgroundColor: 'transparent',
      border: '1px solid #d1d5db',
      borderRadius: '6px',
      fontSize: '0.8rem',
      cursor: 'pointer',
      color: '#4d4d4d',
    },
  };

  // ✅ Updated (keeps other views intact)
  handleItemDetail = (item, type) => {
    if (type === 'product') {
      this.setState({ activeProductDetail: item });
    } else if (type === 'service') {
      this.setState({ activeServiceDetail: item });
    } else if (type === 'milestone') {
      this.setState({ activeMilestoneDetail: item });
    }
  };


  // Handle back to table view
  handleBackToTable = (type) => {
    if (type === 'product') {
      this.setState({ activeProductDetail: null });
    } else if (type === 'service') {
      this.setState({ activeServiceDetail: null });
    } else if (type === 'milestone') {
      this.setState({ activeMilestoneDetail: null });
    }
  };

  handlepdfDownload(sodata) {
    console.log("116SODATA", sodata);

    var i = new Image();
    i.src = logo;
    let logowidth = 0;
    logowidth = ((i.width - i.height) / i.width) * 100;
    let data = [];
    let servdata = [];
    let servicetotal = 0;
    let itemtotal = 0;
    let servicetaxamt = 0;
    let curdate = moment().format("DD-MM-YYYY HH:mm:ss");

    if (sodata.sotype === "Products" || sodata.sotype === "ProductsServices") {
      data = sodata.itemquotation;

      data = data.map((v) => ({ ...v, cgstamt: (v.taxamount / 2).toFixed(2) }));
      data = data.map((v) => ({ ...v, cgst: v.tax / 2 }));
      data = data.map((v) => ({ ...v, sgstamt: (v.taxamount / 2).toFixed(2) }));
      data = data.map((v) => ({ ...v, sgst: v.tax / 2 }));

      // row-level item total (kept as is)
      data = data.map((v) => ({ ...v, totalprice: v.totalprice }));

      // grand total of all product totals
      itemtotal = data.reduce((sum, v) => sum + (v.totalprice || 0), 0);

    }


    if (sodata.sotype === "Services" || sodata.sotype === "ProductsServices") {
      servdata = sodata.servicequotation;
      servdata = servdata.map((v) => ({
        ...v,
        cgst: v.servicetax / 2,
        sgst: v.servicetax / 2,
        tax: v.servicetax // Add this line to ensure tax field exists for services
      }));
      servicetaxamt = servdata.reduce(
        (a, v) => (a = a + (v.servicetotalwtax - v.servicecost)),
        0
      );
      servicetotal = servdata.reduce((a, v) => (a = a + v.servicecost), 0);
    }

    let date = moment(sodata.createdAt).format("DD-MM-YYYY");
    let tablecolp, tablecols;

    let total = (sodata.sototalwtax - sodata.totaltaxamount).toFixed(2);
    let totaltaxamount = sodata.totaltaxamount.toFixed(2);
    let sototalwtax = sodata.sototalwtax.toFixed(2);
    let advance = sodata.advanceamountreq.toFixed(2);

    let curcovrate = sodata.currency !== currency ? sodata.curconversionrate : 1;
    if (sodata.sotype === "Products" || sodata.sotype === "ProductsServices") {
      data.forEach((item) => {
        item.price = (item.price * curcovrate).toFixed(2);
        item.taxamount = (item.taxamount * curcovrate).toFixed(2);
        item.totalpricewtax = (item.totalpricewtax * curcovrate).toFixed(2);

        // For GST
        item.cgstamt = item.cgstamt ? (item.cgstamt * curcovrate).toFixed(2) : 0;
        item.sgstamt = item.sgstamt ? (item.sgstamt * curcovrate).toFixed(2) : 0;

        // For VAT, keep tax percentage for display
        if (sodata.taxtype === "VAT") {
          item.tax = item.tax || 0; // ensures VAT column is never blank
        }
      });
    }


    total = (total * curcovrate).toFixed(2);
    totaltaxamount = (totaltaxamount * curcovrate).toFixed(2);
    sototalwtax = (sototalwtax * curcovrate).toFixed(2);
    advance = (advance * curcovrate).toFixed(2);

    // Determine table columns based on tax type
    if (sodata.taxrequired === true) {
      if (sodata.taxtype === "GST" && ccountry === "India") {
        if (sodata.gsttype === "INTRASTATE") {
          tablecolp = [
            { header: "Name of Product / Service", dataKey: "name" },
            { header: "HSN/SCA", dataKey: "hsn" },
            { header: "Quantity", dataKey: "quantity" },
            { header: `Rate in (${sodata.currency})`, dataKey: "price" },
            { header: "UOM", dataKey: "uom" },
            { header: "Discount (%)", dataKey: "discount" },
            // { header: "SGST (%)", dataKey: "sgst" },
            { header: `Total (${sodata.currency})`, dataKey: "totalpricewtax" },
          ];
        } else {
          tablecolp = [
            { header: "Name of Product / Service", dataKey: "name" },
            { header: "HSN/SCA", dataKey: "hsn" },
            { header: "Quantity", dataKey: "quantity" },
            { header: `Rate in (${sodata.currency})`, dataKey: "price" },
            { header: "UOM", dataKey: "uom" },

            { header: "Discount (%)", dataKey: "discount" },
            // { header: "IGST (%)", dataKey: "tax" },
            { header: `Total (${sodata.currency})`, dataKey: "totalpricewtax" },
          ];
        }
      } else {
        if (sodata.taxtype === "GST") {
          tablecolp = [
            { header: "Name of Product / Service", dataKey: "name" },
            { header: "HSN/SCA", dataKey: "hsn" },
            { header: "Quantity", dataKey: "quantity" },
            { header: `Rate in (${sodata.currency})`, dataKey: "price" },
            { header: "UOM", dataKey: "uom" },

            { header: "Discount (%)", dataKey: "discount" },
            // { header: "GST(%)", dataKey: "tax" },
            { header: `Total (${sodata.currency})`, dataKey: "totalpricewtax" },
          ];
        } else {
          tablecolp = [
            { header: "Name of Product / Service", dataKey: "name" },
            { header: "VAT (%)", dataKey: "tax" },
            { header: "Quantity", dataKey: "quantity" },
            { header: `Rate in (${sodata.currency})`, dataKey: "price" },
            { header: "UOM", dataKey: "uom" },
            { header: "Discount (%)", dataKey: "discount" },
            { header: `Total (${sodata.currency})`, dataKey: "totalpricewtax" },
          ];

        }
      }
    } else {
      tablecolp = [
        { header: "Name of Product / Service", dataKey: "name" },
        { header: "VAT (%)", dataKey: "tax" },
        { header: "Quantity", dataKey: "quantity" },
        { header: `Rate in (${sodata.currency})`, dataKey: "price" },
        { header: "UOM", dataKey: "uom" },
        { header: "Discount (%)", dataKey: "discount" },
        { header: `Total (${sodata.currency})`, dataKey: "totalpricewtax" },
      ];


    }
    const toWords = new ToWords();
    var totalinwords = toWords.convert(sototalwtax);
    // Fix the "Thousand Hundred" issue
    totalinwords = totalinwords.replace(/Thousand Hundred/g, "Thousand One Hundred");
    var advanceinwords = toWords.convert(advance);

    var advanceinwords = toWords.convert(advance);
    const doc = new jsPDF("p", "pt", [842, 595]);


    // ----------------- Page Size -----------------
    const pageSize = doc.internal.pageSize;
    const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
    const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();

    // ----------------- Border Variables -----------------
    const leftBorder = 15;
    const rightBorder = pageWidth - 15;
    const topBorder = 25;
    const bottomBorder = pageHeight - 40;


    const colX1 = pageWidth / 2 + 20;

    // Add fonts
    doc.addFileToVFS("Amiri-Regular.ttf", amiriFont);
    doc.addFont("Amiri-Regular.ttf", "Amiri", "normal");
    doc.addFileToVFS("Amiri-Bold.ttf", amiriBoldFont);
    doc.addFont("Amiri-Bold.ttf", "AmiriBold", "bold");

    let y = 0;


    const midEastCurrencies = ["AED", "SAR", "KWD", "QAR", "OMR"]; // Add all required
    const isMiddleEastCurrency = midEastCurrencies.includes(sodata.currency);
    // ---------------- HEADER ----------------
    doc.setDrawColor(0, 0, 0);
    doc.setFontSize(6);

    // --- English date on left (always) ---
    doc.setFont("helvetica", "bold");
    // doc.text(`${curdate}`, 18, 20);

    // --- Title ---
    doc.setFontSize(10);
    doc.setFont("AmiriBold", "bold");

    const orderText = isMiddleEastCurrency ? "فاتورة / Quotation" : "QUOTATION";
    const textWidth = doc.getTextWidth(orderText);
    doc.text(orderText, pageWidth / 2 - textWidth / 2, 17);

    // --- Arabic date on right (only for Middle East currencies) ---
    if (isMiddleEastCurrency) {
      doc.setFont("Amiri", "normal"); // Registered font
      doc.setFontSize(6);
      const arabicNumbers = { "0": "٠", "1": "١", "2": "٢", "3": "٣", "4": "٤", "5": "٥", "6": "٦", "7": "٧", "8": "٨", "9": "٩" };
      const convertToArabicNumbers = (str) => str.replace(/\d/g, d => arabicNumbers[d]);
      const curdateArabic = convertToArabicNumbers(curdate);
      // doc.text(curdateArabic, pageWidth - 18, 20, { align: "right" });
    }

    doc.setFontSize(7);


    //-------------------------- Wrap Smart text -------------------------

    // Put this at top of the module (above handlepdfDownload)
    function wrapTextSmart(str, max = 50) {
      if (!str && str !== 0) return [];           // handle empty/falsy
      str = String(str);

      // No whitespace: force-split every `max` characters
      if (!/\s/.test(str)) {
        const chunks = [];
        for (let i = 0; i < str.length; i += max) {
          chunks.push(str.substring(i, i + max));
        }
        return chunks;
      }

      // Normal word-based wrapping with fallback split for very long words
      const words = str.split(/\s+/);
      const lines = [];
      let current = "";

      words.forEach(w => {
        const candidate = current ? current + " " + w : w;
        if (candidate.length <= max) {
          current = candidate;
        } else {
          if (current) lines.push(current);
          // if single word too long, split the word
          if (w.length > max) {
            for (let i = 0; i < w.length; i += max) {
              lines.push(w.substring(i, i + max));
            }
            current = "";
          } else {
            current = w;
          }
        }
      });

      if (current) lines.push(current);
      return lines;
    }


    // ---------------- LEFT BLOCK 1: Company Info (Smart Wrapping) ----------------
    doc.setFontSize(7).setFont("helvetica", "bold").setTextColor("#000000");

    const clientNameStr2 = (clientname || "").toUpperCase();
    const clientLines2 = wrapTextSmart(clientNameStr2, 50);
    clientLines2.forEach((ln, i) => doc.text(ln, 25, 43 + i * 8));
    let companyY = 43 + clientLines2.length * 8 + 5;

    // Address block
    doc.setFont("helvetica", "normal").setFontSize(6).setTextColor(51, 51, 51);
    [address, address2, `${ccity}, ${cstate}, ${ccountry} - ${czip}`]
      .filter(l => l)
      .forEach(l => {
        const wrapped = wrapTextSmart(l.toUpperCase(), 60);
        wrapped.forEach((line, i) => {
          doc.text(line, 25, companyY + i * 8);
        });
        companyY += wrapped.length * 8;
      });
    companyY += 5;

    doc.setFont("helvetica", "normal").setFontSize(6.5).setTextColor("#000000");

    // GSTIN
    if (gstin && ccountry === "India") {
      doc.setFont("helvetica", "bold").text("GSTIN :", 25, companyY);
      const gstLines = wrapTextSmart(gstin, 45);
      gstLines.forEach((line, i) => {
        doc.setFont("helvetica", "normal")
          .text(line, 55, companyY + i * 8);
      });
      companyY += gstLines.length * 8 + 2;
    }

    // PAN
    if (pan && ccountry === "India") {
      doc.setFont("helvetica", "bold").text("PAN :", 25, companyY);
      const panLines = wrapTextSmart(pan, 45);
      panLines.forEach((line, i) => {
        doc.setFont("helvetica", "normal")
          .text(line, 45, companyY + i * 8);
      });
      companyY += panLines.length * 8 + 2;
    }

    // Licenses
    if (this.state.licenses && this.state.licenses !== "") {
      this.state.licenses.forEach((e) => {
        doc.setFont("helvetica", "bold").text(`${e.name} :`, 25, companyY);
        const licLines = wrapTextSmart(e.number, 45);
        licLines.forEach((line, i) => {
          doc.setFont("helvetica", "normal")
            .text(line, 55, companyY + i * 8);
        });
        companyY += licLines.length * 8 + 2;
      });
    }

    // Email
    if (companyemail) {
      doc.setFont("helvetica", "bold").text("EMAIL ID :", 25, companyY);
      const emailLines = wrapTextSmart(companyemail, 65);
      emailLines.forEach((line, i) => {
        doc.setFont("helvetica", "normal")
          .text(line, 60, companyY + i * 8);
      });
      companyY += emailLines.length * 8 + 2;
    }

    // Phone
    if (contactnumber) {
      doc.setFont("helvetica", "bold").text("PHONE NO :", 25, companyY);
      const phoneLines = wrapTextSmart(contactnumber, 65);
      phoneLines.forEach((line, i) => {
        doc.setFont("helvetica", "normal")
          .text(line, 65, companyY + i * 8);
      });
      companyY += phoneLines.length * 8 + 2;
    }

    let leftBlock1Bottom = companyY;


    // ---------------- RIGHT BLOCK SETTINGS ----------------


    const marginLeft = 15;
    const marginRight = 10;             // left column (middle)
    const colX2 = colX1 + 110;                // divider
    const colX3 = pageWidth - marginRight;    // right edge
    const rowHeight = 14;

    // ---------------- RIGHT BLOCK 1: Logo + Top 3 Fields ----------------
    // Calculate same coordinates you already use
    const posX = pageWidth - 60 - logowidth;
    const posY = 30;
    const boxWidth = 45 + logowidth;
    const boxHeight = 55;

    const logoW = 75, logoH = 55;
    const logoX = rightBorder - logoW;
    const logoY = topBorder + 5;
    let logoBottomY = logoY + logoH;



    doc.setFillColor(240, 240, 240);
    doc.rect(logoX, logoY, logoW, logoH, "F");
    if (logo) {
      doc.addImage(logo, "GIF", logoX, logoY, logoW, logoH);
    }



    logoBottomY = 30 + 55;
    function capitalizeText(str) {
      if (!str) return "";
      return String(str).toUpperCase();  // or .replace(/\b\w/g, c => c.toUpperCase()) for Title Case
    }

    let topFields = [
      ["Quotation ID", capitalizeText(sodata.customqtid || "")],
      ["Quotation Date", date || ""],
      ["Quotation Reference", capitalizeText(sodata.quotationref || "N/A")],
    ];

    // Dynamic height → stretch between logoBottomY+10 and block1Bottom
    let rightBlock1Y = logoBottomY + 5;
    let block1Bottom = leftBlock1Bottom; // align with left block
    let totalHeightBlock1 = block1Bottom - rightBlock1Y;
    let dynamicRowHeight1 = totalHeightBlock1 / topFields.length;

    // Outer box (no right border)
    doc.setDrawColor("#000000").setLineWidth(0.1);

    // Top line (fixed start below logo)
    doc.line(colX1, rightBlock1Y, colX3, rightBlock1Y);

    // Left vertical line (from page top border down to aligned bottom)
    doc.line(colX1, 25, colX1, block1Bottom);

    // Middle divider
    doc.line(colX2, rightBlock1Y, colX2, block1Bottom);

    // Bottom border aligned with left block
    doc.line(marginLeft, block1Bottom, pageWidth - marginRight, block1Bottom);

    // Rows
    topFields.forEach((f, idx) => {
      let rowTop = rightBlock1Y + idx * dynamicRowHeight1;
      let rowCenter = rowTop + dynamicRowHeight1 / 2 + 2;

      // Label
      doc.setFont("helvetica", "bold").setFontSize(7).setTextColor("#000000");
      doc.text(f[0], colX1 + 5, rowCenter);

      // Value
      doc.setFont("helvetica", "normal").setFontSize(7);
      doc.text(String(f[1] || ""), colX2 + 5, rowCenter);

      if (idx < topFields.length - 1) {
        doc.line(colX1, rowTop + dynamicRowHeight1, colX3, rowTop + dynamicRowHeight1);
      }
    });

    let rightBlock1Bottom = block1Bottom;
    // ---------------- LEFT BLOCK 2: Billing Address ----------------
    let billingY = block1Bottom + 10;
    doc.setFontSize(6.5).setFont("helvetica", "normal").setTextColor("#000000");
    doc.text(`(Billing Address)`, 25, billingY);

    billingY += 10;

    // Customer Name
    doc.setFontSize(7).setFont("helvetica", "bold").setTextColor("#000000");
    const custNameStr = (sodata.customer || "").toUpperCase();
    const custNameLines = wrapTextSmart(custNameStr, 50);
    custNameLines.forEach((ln, i) => doc.text(ln, 25, billingY + i * 8));
    billingY += custNameLines.length * 8 + 2;

    // Address lines
    doc.setFont("helvetica", "normal").setFontSize(6).setTextColor("#333333");
    [
      sodata.custaddress,
      sodata.custaddress2,
      `${sodata.custcityname}, ${sodata.custstatename}, ${sodata.custcountryname} - ${sodata.custzip}`
    ]
      .filter(l => l)
      .forEach(l => {
        const wrapped = wrapTextSmart(l.toUpperCase(), 60);
        wrapped.forEach((line, i) => {
          doc.text(line, 25, billingY + i * 8);
        });
        billingY += wrapped.length * 8;
      });
    billingY += 5;

    // GSTIN
    if (sodata.custgstin) {
      doc.setFont("helvetica", "bold").setFontSize(6.5).setTextColor("#000000");
      doc.text("GSTIN :", 25, billingY);

      const gstLines = wrapTextSmart(sodata.custgstin, 45);
      gstLines.forEach((line, i) => {
        doc.setFont("helvetica", "normal")
          .text(line, 55, billingY + i * 8);
      });
      billingY += gstLines.length * 8 + 2;

      // PAN (derived from GSTIN)
      doc.setFont("helvetica", "bold").text("PAN :", 25, billingY);
      const panStr = sodata.custgstin?.substring(2, 12) || "";
      const panLines = wrapTextSmart(panStr, 45);
      panLines.forEach((line, i) => {
        doc.setFont("helvetica", "normal")
          .text(line, 45, billingY + i * 8);
      });
      billingY += panLines.length * 8 + 2;
    }

    // PHONE NO
    if (sodata.custcontactnumber) {
      doc.setFont("helvetica", "bold").text("PHONE NO :", 25, billingY);
      const phoneLines = wrapTextSmart(String(sodata.custcontactnumber), 45);
      phoneLines.forEach((line, i) => {
        doc.setFont("helvetica", "normal")
          .text(line, 65, billingY + i * 8);
      });
      billingY += phoneLines.length * 8 + 2;
    }

    let leftBlock2Bottom = billingY;


    // ---------------- RIGHT BLOCK 2: Remaining 4 Fields ----------------
    let bottomFields = [
      ["Customer ID", capitalizeText(sodata.customcustomerid || "")],
      ["Customer Type", capitalizeText(sodata.validuntil || "N/A")],
      ["Mode / Payment Terms", `${sodata.paymentterms} Days` || ""],
      ["Quotation Validity", capitalizeText(sodata.qvalidity || "N/A")],
      ["Sales Person / Contact No.", capitalizeText(sodata.agent && sodata.agentphno ? `${sodata.agent}\n${sodata.agentphno}` : "N/A")]

    ];

    let rightBlock2Y = block1Bottom + 10;

    // Dynamic row height → evenly divide available height by field count
    let totalRightBlockHeight = leftBlock2Bottom - block1Bottom;
    let dynamicRowHeight2 = totalRightBlockHeight / bottomFields.length;

    // Left vertical line
    doc.setDrawColor("#000000").setLineWidth(0.1);
    doc.line(colX1, block1Bottom, colX1, leftBlock2Bottom);

    // Middle divider line
    doc.line(colX2, block1Bottom, colX2, leftBlock2Bottom);

    bottomFields.forEach((f, idx) => {
      let rowTop = block1Bottom + idx * dynamicRowHeight2;
      let rowCenter = rowTop + dynamicRowHeight2 / 2 + 2;

      doc.setFont("helvetica", "bold").setFontSize(7).setTextColor("#000000");
      doc.text(f[0], colX1 + 5, rowCenter);

      doc.setFont("helvetica", "normal").setFontSize(7);

      // Apply padding only if both agent and agentphno exist
      if (
        f[0] === "Sales Person / Contact No." &&
        sodata.agent &&
        sodata.agentphno &&
        f[1] !== "N/A"
      ) {
        doc.setFontSize(5.5);
        const padding = 3; // 2px top/bottom padding
        const rowBottom = rowTop + 4 + dynamicRowHeight2;
        let lines = String(f[1]).split("\n");
        const availableHeight = rowBottom - rowTop - 2 * padding;
        const lineHeight = availableHeight / lines.length;

        lines.forEach((line, i) => {
          doc.text(line, colX2 + 5, rowTop + padding + lineHeight * (i + 0.5));
        });
      } else {
        // Default center placement for other rows or if agent/phno missing
        doc.text(String(f[1] || ""), colX2 + 5, rowCenter);
      }

      if (idx < bottomFields.length - 1) {
        doc.line(colX1, rowTop + dynamicRowHeight2, colX3, rowTop + dynamicRowHeight2);
      }
    });


    let rightBlock2Bottom = leftBlock2Bottom;

    // ---------------- ALIGN BLOCK 2 ----------------
    let block2Bottom = leftBlock2Bottom;

    // Merge items & services into one array
    console.log("SODATA420", sodata.itemquotation);
    const mergedData = [
      ...(sodata.itemquotation || []).map(item => ({
        name: item.name,
        description: item.description,
        hsn: item.hsn,
        quantity: item.quantity,
        price: item.price,
        uom: item.uom,
        discount: item.discount,
        tax: item.tax, // Ensure tax is included for products
        totalpricewtax: item.totalprice
      })),
      ...(sodata.servicequotation || []).map(service => ({
        name: service.service,
        description: service.description,
        hsn: service.servicecode,
        quantity: 1,
        price: service.servicecost,
        uom: "N/A",
        discount: 0,
        tax: service.servicetax, // Add tax for services
        totalpricewtax: service.servicecost
      }))
    ];


    function wrapText(text, maxLen = 60) {
      if (!text) return [];

      const lines = [];
      // Split by manual newlines first
      const rawLines = text.split(/\r?\n/);

      rawLines.forEach(rawLine => {
        let currentLine = "";
        const words = rawLine.split(" ");

        words.forEach(word => {
          if (word.length > maxLen) {
            if (currentLine) {
              lines.push(currentLine.trim());
              currentLine = "";
            }
            for (let i = 0; i < word.length; i += maxLen) {
              lines.push(word.substring(i, i + maxLen));
            }
          } else {
            if ((currentLine + word).length > maxLen) {
              lines.push(currentLine.trim());
              currentLine = word + " ";
            } else {
              currentLine += word + " ";
            }
          }
        });

        if (currentLine.trim()) lines.push(currentLine.trim());

        // Add empty line if there was a manual break
        if (rawLine === "" || rawLine.endsWith("\n")) {
          lines.push("");
        }
      });

      return lines;
    }

    // =================== USAGE ===================
    const processedData = mergedData.map(item => {
      const nameLines = wrapText(item.name || "");
      const descLines = wrapText(item.description || "");
      const lineCount = nameLines.length + descLines.length;
      const lineHeight = 7;
      const rowHeight = Math.max(14, lineCount * lineHeight + 4);

      return {
        ...item,
        nameLines,
        nameDesc: item.name,
        descLines,
        _rowHeight: rowHeight
      };
    });

    // Update first column definition
    tablecolp[0] = { header: "Name of Product / Service", dataKey: "nameDesc" };

    const rightMiddle = colX2;
    const pageMiddle = colX1;
    const rightMiddleLine = (colX2 + colX3) / 2;

    const tableWidth = doc.internal.pageSize.getWidth() - 15 - 10; // total table width
    const leftGroupWidth = pageMiddle - 15;
    const middleGroupWidth = rightMiddle - pageMiddle;
    const rightGroupWidth =
      tableWidth - (leftGroupWidth + middleGroupWidth); // rightMiddle → right margin

    // ---------------- PRODUCTS TABLE ----------------//
    y = block2Bottom;
    if (["Products", "ProductsServices", "Services"].includes(sodata.sotype)) {
      const lastColIndex = tablecolp.length - 1;

      autoTable(doc, {
        theme: "grid",
        startY: y,
        margin: { top: 0, bottom: 0, right: 10, left: 15 },
        tableWidth: "auto",
        pageBreak: "auto",        // ✅ automatic page breaking
        rowPageBreak: "auto",     // ✅ split long rows correctly
        showHead: "everyPage",    // ✅ keep headers repeating
        styles: {
          textColor: [0, 0, 0],
          fontSize: 7,
          cellPadding: 3,
          minCellHeight: 14,
          lineColor: [0, 0, 0],
          lineWidth: 0.1,
          valign: "middle",
          halign: "center"
        },
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          fontStyle: "bold",
          lineWidth: 0.1,
          lineColor: [0, 0, 0],
          minCellHeight: 18,
          fontSize: 6.5
        },
        bodyStyles: {
          lineColor: [0, 0, 0],
          lineWidth: 0.1,
          minCellHeight: 30
        },

        columnStyles: {
          0: { cellWidth: leftGroupWidth * 0.8 },
          1: { cellWidth: leftGroupWidth * 0.2 },
          2: { cellWidth: middleGroupWidth * 0.45 },
          3: { cellWidth: middleGroupWidth * 0.55 },

          ...Array.from({ length: lastColIndex - 5 }, (_, i) => ({
            [i + 4]: {
              cellWidth: ((rightMiddleLine - rightMiddle) * 0.5) / (lastColIndex - 5)
            }
          })).reduce((a, b) => Object.assign(a, b), {}),

          [lastColIndex - 1]: { cellWidth: (rightMiddleLine - rightMiddle) * 0.5 },
          [lastColIndex]: { cellWidth: colX3 - rightMiddleLine }
        },

        didParseCell: function (data) {
          data.cell.styles.valign = "middle";

          if (data.section === "body") {

            if (data.column.index === 0) {
              const { nameLines, descLines } = data.row.raw;

              // Calculate required height
              const totalLines = (nameLines?.length || 0) + (descLines?.length || 0);
              const lineHeight = 7; // your spacing between lines
              const neededHeight = Math.max(14, totalLines * lineHeight + 4);

              // Tell AutoTable to expand the row
              data.cell.height = neededHeight;
              data.row.height = Math.max(data.row.height, neededHeight);
            }

            // Handle VAT percentage display for both products and services
            const colDataKey = tablecolp[data.column.index].dataKey;
            if (colDataKey === "tax" && sodata.taxtype === "VAT") {
              // Get the tax value from the original row data
              const taxValue = data.row.raw.tax || 0;
              data.cell.text = [taxValue + "%"];
            }
          }


          if (data.section === "head") {
            if (data.column.index === 0) {
              data.cell.styles.cellPadding = {
                left: 10,
                right: 2,
                top: 2,
                bottom: 2
              };
              data.cell.styles.halign = "left";
            } else if (data.column.index === lastColIndex) {
              data.cell.styles.halign = "right";
            } else {
              data.cell.styles.halign = "center";
            }
          }

          if (data.section === "body") {
            if (data.column.index === 0) {
              data.cell.text = [""]; // hide default, custom draw
              data.cell.styles.halign = "left";
            } else if (data.column.index === lastColIndex) {
              data.cell.styles.halign = "right";
            } else {
              data.cell.styles.halign = "center";
            }

            const dataKey = tablecolp[data.column.index].dataKey;

            if (
              data.row.raw[dataKey] === null ||
              data.row.raw[dataKey] === undefined ||
              data.row.raw[dataKey] === ""
            ) {
              data.cell.text = ["N/A"];
            }
            if (["price", "totalpricewtax"].includes(dataKey)) {
              if (!isNaN(data.cell.raw)) {
                const value = Number(data.cell.raw).toFixed(2);
                data.cell.text = [rupeeFormatter(value)];
              }
            }
          }
        },

        didDrawCell: function (data) {
          if (data.column.index === 0) {
            data.cell.styles.lineWidth = {
              top: data.cell.styles.lineWidth,
              right: data.cell.styles.lineWidth,
              bottom: data.cell.styles.lineWidth,
              left: 0
            };
          } else if (data.column.index === lastColIndex) {
            const yTop = data.cell.y;
            const yBottom = data.cell.y + data.cell.height;
            doc.setDrawColor(0, 0, 0);
            doc.setLineWidth(0.1);
            doc.line(rightMiddleLine, yTop, rightMiddleLine, yBottom);

            data.cell.styles.lineWidth = {
              top: data.cell.styles.lineWidth,
              right: 0,
              bottom: data.cell.styles.lineWidth,
              left: 0
            };
          }

          // Custom text draw for first col
          if (data.section === "body" && data.column.index === 0) {
            data.cell.text = [""];
            const { nameLines, descLines } = data.row.raw;

            const textX = data.cell.x + 10; // padding left
            let textY = data.cell.y + 8; // padding top

            // Draw wrapped name lines
            if (nameLines && nameLines.length) {
              doc.setFont("helvetica", "bold");
              doc.setFontSize(6.5);
              doc.setTextColor(0, 0, 0);
              nameLines.forEach(line => {
                doc.text(line, textX, textY, { baseline: "top" });
                textY += 8;
              });
            }

            // Draw wrapped description lines
            if (descLines && descLines.length) {
              doc.setFont("helvetica", "normal");
              doc.setFontSize(5);
              doc.setTextColor(51, 51, 51);
              descLines.forEach(line => {
                doc.text(line, textX, textY, { baseline: "top" });
                textY += 6;
              });
            }
          }
        },

        body: processedData,
        columns: tablecolp
      });
    }

    y = doc.autoTable.previous.finalY || topBorder;
    if (y + 300 > bottomBorder) {
      doc.addPage([595.28, 841.89]);
      y = topBorder;
    }


    // ==================== CONFIGURATION ====================

    const leftMargin = 15;

    // Tax type configuration
    const isIntraStateGST =
      sodata.taxtype === "GST" &&
      ccountry === "India" &&
      sodata.gsttype === "INTRASTATE";
    const sectionHeight = isIntraStateGST ? 100 : 80;

    // ==================== INITIAL SETUP ====================
    // y = doc.autoTable.previous.finalY;


    if (y + 50 > bottomBorder) {
      doc.addPage([595.28, 841.89]);
      y = topBorder;
      doc.setFont("helvetica", "normal");
      doc.setTextColor("#000");
      doc.setFontSize(7);
    }


    // Draw section borders
    doc.setDrawColor("#000000");
    doc.setLineWidth(0.1);
    doc.line(leftMargin, y, colX3, y); // Top border
    doc.line(rightMiddleLine, y, rightMiddleLine, y + sectionHeight); // Middle vertical line
    doc.line(colX2, y, colX2, y + sectionHeight);

    // ==================== LEFT SECTION ====================
    doc.setFont("helvetica", "bold");
    doc.setFontSize(6);
    doc.text("Amount Chargeable (in words):", 25, y + 60);

    doc.setFont("helvetica", "normal");
    doc.setTextColor("#333333");
    doc.setFontSize(6);

    const amountText = `${totalinwords} (${sodata.currency}) Only /-`;
    const splitAmountText = doc.splitTextToSize(amountText, colX2 - 30);
    doc.text(splitAmountText, 25, y + 70);

    doc.setFontSize(7);
    doc.setTextColor("#000000");

    // ==================== RIGHT SECTION ====================
    let subtotal = servicetotal + itemtotal;
    doc.setFont("helvetica", "bold");
    doc.text("Sub Total", colX2 + 10, y + 13);
    doc.text(`${rupeeFormatter(subtotal.toFixed(2))}`,
      sodata.sotype === "ProductsServices" ? colX3 - 2 : colX3 - 2,
      y + 13,
      "right"
    );

    // if (sodata.sotype === "ProductsServices" || sodata.sotype === "Services") {
    //   doc.text(
    //     `${rupeeFormatter(servicetotal.toFixed(2))}`,
    //     sodata.sotype === "ProductsServices" ? 480 : 583,
    //     y + 13,
    //     "right"
    //   );
    // }

    // if (sodata.sotype === "ProductsServices" || sodata.sotype === "Products") {
    //   doc.text(
    //     `${rupeeFormatter(sototalwtax)}`,
    //     583,
    //     y + 13,
    //     "right"
    //   );
    // }

    doc.line(colX2, y + 20, colX3, y + 20);
    if (isIntraStateGST) {
      // ----------------- CGST -----------------
      doc.text("CGST", colX2 + 10, y + 33);
      doc.setFont("helvetica", "normal");
      if (sodata.sotype === "ProductsServices") {
        const cgstCombined = (Number(totaltaxamount) + Number(servicetaxamt)) / 2;
        doc.text(`${rupeeFormatter(cgstCombined.toFixed(2))}`, colX3 - 2, y + 33, "right");
      } else if (sodata.sotype === "Products") {
        doc.text(`${rupeeFormatter((totaltaxamount / 2).toFixed(2))}`, colX3 - 2, y + 33, "right");
      } else if (sodata.sotype === "Services") {
        doc.text(`${rupeeFormatter((servicetaxamt / 2).toFixed(2))}`, colX3 - 2, y + 33, "right");
      }

      doc.line(colX2, y + 40, colX3, y + 40);

      // ----------------- SGST -----------------
      doc.setFont("helvetica", "bold");
      doc.text("SGST", colX2 + 10, y + 53);
      doc.setFont("helvetica", "normal");
      if (sodata.sotype === "ProductsServices") {
        const sgstCombined = (Number(totaltaxamount) + Number(servicetaxamt)) / 2;
        doc.text(`${rupeeFormatter(sgstCombined.toFixed(2))}`, colX3 - 2, y + 53, "right");
      } else if (sodata.sotype === "Products") {
        doc.text(`${rupeeFormatter((totaltaxamount / 2).toFixed(2))}`, colX3 - 2, y + 53, "right");
      } else if (sodata.sotype === "Services") {
        doc.text(`${rupeeFormatter((servicetaxamt / 2).toFixed(2))}`, colX3 - 2, y + 53, "right");
      }

      doc.line(colX2, y + 60, colX3, y + 60);
      doc.setFont("helvetica", "bold");
      // ----------------- Discount -----------------
      doc.text(`Discount (${sodata.discount ?? 0}%)`, colX2 + 10, y + 73);
      doc.setFont("helvetica", "normal");
      doc.text(`${(sodata.discount ?? 0).toFixed(2)}`, colX3 - 2, y + 73, { align: "right" });

      doc.line(colX2, y + 80, colX3, y + 80);

      // ----------------- Total -----------------
      doc.setFont("helvetica", "bold");
      doc.text("Total", colX2 + 10, y + 93);
      doc.setFont("helvetica", "bold");
      doc.text(`${rupeeFormatter(sototalwtax)}`, colX3 - 2, y + 93, "right");
      doc.setFont("helvetica", "normal");
      doc.line(colX2, y + 100, colX3, y + 100);

    } else {
      // ----------------- IGST / GST / VAT -----------------
      doc.setFont("helvetica", "bold");
      const taxLabel =
        sodata.taxtype === "GST" && ccountry === "India"
          ? "IGST"
          : sodata.taxtype === "GST"
            ? "GST"
            : "VAT";

      doc.text(taxLabel, colX2 + 10, y + 33);
      doc.setFont("helvetica", "normal");
      if (sodata.sotype === "ProductsServices") {
        const combinedTax = Number(totaltaxamount) + Number(servicetaxamt);
        doc.text(`${rupeeFormatter(combinedTax.toFixed(2))}`, colX3 - 2, y + 33, "right");
      } else if (sodata.sotype === "Products") {
        doc.text(`${rupeeFormatter(totaltaxamount)}`, colX3 - 2, y + 33, "right");
      } else if (sodata.sotype === "Services") {
        doc.text(`${rupeeFormatter(servicetaxamt.toFixed(2))}`, colX3 - 2, y + 33, "right");
      }


      doc.line(colX2, y + 40, colX3, y + 40);
      doc.setFont("helvetica", "bold");
      doc.text(`Discount (${sodata.discount ?? 0}%)`, colX2 + 10, y + 53);
      doc.setFont("helvetica", "normal");
      doc.text(`${(sodata.discount ?? 0).toFixed(2)}`, colX3 - 2, y + 53, {
        align: "right",
      });
      doc.setFont("helvetica", "bold");
      doc.line(colX2, y + 60, colX3, y + 60);
      doc.text("Total", colX2 + 10, y + 73);
      doc.setFont("helvetica", "bold");
      doc.text(`${rupeeFormatter((sototalwtax))}`, colX3 - 2, y + 73, "right");

      doc.line(colX2, y + 80, colX3, y + 80);
    }

    // === Get bottom line of totals (common for left + right) ===
    const totalsBottomY = isIntraStateGST ? y + 100 : y + 80;
    doc.line(leftMargin, totalsBottomY, colX3, totalsBottomY);

    const blankBoxHeight = 50;

    let sectionBottomY = totalsBottomY + blankBoxHeight;




    if (sectionBottomY + 100 > bottomBorder) {
      doc.addPage([595.28, 841.89]);
      sectionBottomY = topBorder;
      doc.setFont("helvetica", "normal");
      doc.setTextColor("#000");
      doc.setFontSize(7);
    }



    // // ==================== MILESTONES TABLE ====================

    // // Collect all milestones from servicequotation
    // let milestoneData = [];
    // if (sodata.sotype === "Services" || sodata.sotype === "ProductsServices") {
    //   (sodata.servicequotation || []).forEach(service => {
    //     if (service.milestonequotation && service.milestonequotation.length > 0) {
    //       service.milestonequotation.forEach(m => {
    //         milestoneData.push({
    //           name: m.name,
    //           expecteddate: m.expecteddate 
    //             ? moment(m.expecteddate).format("DD-MM-YYYY") 
    //             : "",
    //           percentage: `${m.percentage} %`,
    //           amount: rupeeFormatter(parseFloat(m.amount).toFixed(2))
    //         });
    //       });
    //     }
    //   });
    // }

    // // Only show milestones if we have milestone data AND it's not a VAT-only case
    // // OR if it's VAT but we have services with milestones
    // if (milestoneData.length > 0 && 
    //     (sodata.taxtype !== "VAT" || 
    //      (sodata.taxtype === "VAT" && (sodata.sotype === "Services" || sodata.sotype === "ProductsServices")))) {
    //   y = totalsBottomY;

    //   autoTable(doc, {
    //     startY: y,
    //     margin: { left: 15, right: 10 },
    //     head: [[
    //       "Milestone Name",
    //       "Expected Date",
    //       "Percentage",
    //       `Amount (${sodata.currency})`
    //     ]],
    //     body: milestoneData.map(m => [
    //       m.name,
    //       m.expecteddate,
    //       m.percentage,
    //       m.amount
    //     ]),
    //     theme: "grid",
    //     styles: {
    //       fontSize: 6,
    //       cellPadding: 3,
    //       lineColor: [0, 0, 0],
    //       lineWidth: 0.1,
    //       halign: "center",
    //       valign: "middle"
    //     },
    //     headStyles: {
    //       fillColor: [255, 255, 255],
    //       textColor: [0, 0, 0],
    //       fontStyle: "bold",
    //       halign: "center",
    //       valign: "middle",
    //       lineColor: [0, 0, 0],
    //       lineWidth: 0.1,
    //       fontSize: 6.5,
    //       minCellHeight: 15
    //     },
    //     columnStyles: {
    //       0: { 
    //         cellWidth: pageMiddle - 15, 
    //         halign: "left", 
    //         fontStyle: "bold",
    //         cellPadding: { left: 10, right: 3, top: 3, bottom: 3 } 
    //       },
    //       1: { cellWidth: colX2 - pageMiddle, halign: "center" },
    //       2: { cellWidth: (colX3 - colX2 ) * 0.5, halign: "center" },
    //       3: { cellWidth: (colX3 - colX2) * 0.5, halign: "right" }
    //     },
    //     didParseCell: function (data) {
    //       // Override header alignment for col 0 and col 3
    //       if (data.section === "head") {
    //         if (data.column.index === 0) {data.cell.styles.halign = "left"; data.cell.styles.cellPadding = {left: 10};}
    //         if (data.column.index === 3) data.cell.styles.halign = "right";
    //       }
    //     }
    //   });

    //   y = doc.autoTable.previous.finalY; // update for next section
    // } else {
    // }
    // If no milestones, start from totalsBottomY


    y = totalsBottomY;
    // ==================== DYNAMIC HSN TABLE ====================

    let hsnData = [];
    if (sodata.sotype === "Products" || sodata.sotype === "ProductsServices") {
      sodata.itemquotation.forEach(item => {
        hsnData.push({
          hsn: item.hsn,
          name: item.name,
          totalprice: (item.price * item.quantity * (1 - (item.discount || 0) / 100)).toFixed(2),
          taxamount: (item.taxamount || 0).toFixed(2),
          tax: item.tax || 0
        });
      });
    }

    if (sodata.sotype === "Services" || sodata.sotype === "ProductsServices") {
      sodata.servicequotation.forEach(service => {
        hsnData.push({
          hsn: service.servicecode,
          name: service.service,
          totalprice: service.servicecost.toFixed(2),
          taxamount: (service.servicetotalwtax - service.servicecost).toFixed(2),
          tax: service.servicetax || 0
        });
      });
    }

    // Only proceed with HSN table if we have data AND it's GST in India
    // Exclude HSN table for VAT
    if (hsnData.length > 0 && sodata.taxtype === "GST" && ccountry === "India") {

      // Group by HSN
      let hsnGroups = {};
      hsnData.forEach(item => {
        if (!hsnGroups[item.hsn]) {
          hsnGroups[item.hsn] = [];
        }
        hsnGroups[item.hsn].push(item);
      });

      // Process groups into rows
      let processedHsnList = [];
      Object.keys(hsnGroups).forEach(hsnCode => {
        const items = hsnGroups[hsnCode];
        const totalTaxable = items.reduce((sum, item) => sum + parseFloat(item.totalprice), 0);
        const totalTax = items.reduce((sum, item) => sum + parseFloat(item.taxamount), 0);

        const isIntraState = sodata.taxtype === "GST" && ccountry === "India" && sodata.gsttype === "INTRASTATE";

        processedHsnList.push({
          hsn: hsnCode,
          totalprice: totalTaxable.toFixed(2),
          taxamount: totalTax.toFixed(2),
          cgstAmt: isIntraState ? (totalTax / 2).toFixed(2) : "0.00",
          sgstAmt: isIntraState ? (totalTax / 2).toFixed(2) : "0.00",
          igstAmt: !isIntraState ? totalTax.toFixed(2) : "0.00"
        });
      });

      // Grand Totals row
      const grandTotals = processedHsnList.reduce(
        (acc, item) => {
          acc.taxable += parseFloat(item.totalprice);
          acc.cgst += parseFloat(item.cgstAmt);
          acc.sgst += parseFloat(item.sgstAmt);
          acc.igst += parseFloat(item.igstAmt);
          acc.totalTax += parseFloat(item.taxamount);
          return acc;
        },
        { taxable: 0, cgst: 0, sgst: 0, igst: 0, totalTax: 0 }
      );

      processedHsnList.push({
        hsn: `Total (${sodata.currency})`,
        totalprice: grandTotals.taxable.toFixed(2),
        cgstAmt: grandTotals.cgst.toFixed(2),
        sgstAmt: grandTotals.sgst.toFixed(2),
        igstAmt: grandTotals.igst.toFixed(2),
        taxamount: grandTotals.totalTax.toFixed(2)
      });

      // Columns (intra vs inter)
      const isIntraStateGST1 = sodata.taxtype === "GST" && ccountry === "India" && sodata.gsttype === "INTRASTATE";

      const hsnColumns = isIntraStateGST1
        ? [
          { header: "HSN/SAC", dataKey: "hsn" },
          { header: `Taxable Amount (${sodata.currency})`, dataKey: "totalprice" },
          { header: "CGST", dataKey: "cgstAmt" },
          { header: "SGST", dataKey: "sgstAmt" },
          { header: "IGST", dataKey: "igstAmt" },
          { header: `Total Tax Amount (${sodata.currency})`, dataKey: "taxamount" }
        ]
        : [
          { header: "HSN/SAC", dataKey: "hsn" },
          { header: `Taxable Amount (${sodata.currency})`, dataKey: "totalprice" },
          { header: "CGST", dataKey: "cgstAmt" },
          { header: "SGST", dataKey: "sgstAmt" },
          { header: "IGST", dataKey: "igstAmt" },
          { header: `Total Tax Amount (${sodata.currency})`, dataKey: "taxamount" }
        ];

      // Convert numeric values to formatted strings with rupeeFormatter while keeping toFixed(2)
      processedHsnList = processedHsnList.map(row => ({
        hsn: row.hsn ?? "",
        totalprice: rupeeFormatter(parseFloat(row.totalprice || 0).toFixed(2)),
        cgstAmt: rupeeFormatter(parseFloat(row.cgstAmt || 0).toFixed(2)),
        sgstAmt: rupeeFormatter(parseFloat(row.sgstAmt || 0).toFixed(2)),
        igstAmt: rupeeFormatter(parseFloat(row.igstAmt || 0).toFixed(2)),
        taxamount: rupeeFormatter(parseFloat(row.taxamount || 0).toFixed(2))
      }));

      const lastHsnColIndex = hsnColumns.length - 1;

      const hsnColumnStyles = {};

      if (isIntraStateGST1) {
        // Calculate widths for different column groups
        const firstColWidth = pageMiddle - 15;
        const lastColWidth = colX3 - rightMiddleLine;

        // Width from colX1 to colX2 for the first two middle columns
        const firstTwoMiddleWidth = (colX2 - (leftMargin + firstColWidth)) / 2;

        // Remaining width for the last two middle columns (from colX2 to rightMiddleLine)
        const lastTwoMiddleWidth = (rightMiddleLine - colX2) / 2;

        hsnColumnStyles[0] = {
          cellWidth: firstColWidth,
          halign: "left",
          cellPadding: { left: 10, right: 3 }
        };
        hsnColumnStyles[1] = { cellWidth: firstTwoMiddleWidth, halign: "center" }; // Taxable Amount
        hsnColumnStyles[2] = { cellWidth: firstTwoMiddleWidth, halign: "center" }; // CGST
        hsnColumnStyles[3] = { cellWidth: lastTwoMiddleWidth, halign: "center" };   // SGST
        hsnColumnStyles[4] = { cellWidth: lastTwoMiddleWidth, halign: "center" };   // IGST
        hsnColumnStyles[5] = { cellWidth: lastColWidth, halign: "right" };          // Total Tax Amount
      } else {
        // Similar logic for non-intra-state case
        const firstColWidth = pageMiddle - 15;
        const lastColWidth = colX3 - rightMiddleLine;

        const firstTwoMiddleWidth = (colX2 - (leftMargin + firstColWidth)) / 2;
        const lastTwoMiddleWidth = (rightMiddleLine - colX2) / 2;

        hsnColumnStyles[0] = {
          cellWidth: firstColWidth,
          halign: "left",
          cellPadding: { left: 10, right: 3 }
        };
        hsnColumnStyles[1] = { cellWidth: firstTwoMiddleWidth, halign: "center" }; // Taxable Amount
        hsnColumnStyles[2] = { cellWidth: firstTwoMiddleWidth, halign: "center" }; // CGST
        hsnColumnStyles[3] = { cellWidth: lastTwoMiddleWidth, halign: "center" };   // SGST
        hsnColumnStyles[4] = { cellWidth: lastTwoMiddleWidth, halign: "center" };   // IGST
        hsnColumnStyles[5] = { cellWidth: lastColWidth, halign: "right" };          // Total Tax Amount
      }

      const hsnBody = processedHsnList.map((item, index) =>
        hsnColumns.map(col => item[col.dataKey] ?? 0)
          .concat(index === processedHsnList.length - 1 ? { isTotalRow: true } : {})
      );
      autoTable(doc, {
        startY: y,
        margin: { left: leftMargin, right: 10 },
        head: [hsnColumns.map(c => c.header)],
        body: hsnBody,
        theme: "grid",
        styles: {
          fontSize: 6,
          cellPadding: 3,
          lineColor: [0, 0, 0],
          lineWidth: 0.1,
          textColor: [0, 0, 0],
        },
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          fontStyle: "bold",
          halign: "center",
          valign: "middle",
          lineColor: [0, 0, 0],
          lineWidth: 0.1,
          fontSize: 6.5
        },
        bodyStyles: {
          halign: "right",
          lineColor: [0, 0, 0],
          lineWidth: 0.1,
          textColor: [0, 0, 0],
        },
        columnStyles: hsnColumnStyles,

        didParseCell: function (data) {
          data.cell.styles.valign = "middle";

          // Head alignment
          if (data.section === "head") {
            if (data.column.index === 0) {
              data.cell.styles.halign = "left";
              data.cell.styles.cellPadding = { left: 10, right: 3, top: 3, bottom: 3 };
            } else if (data.column.index === lastHsnColIndex) {
              data.cell.styles.halign = "right";
            } else {
              data.cell.styles.halign = "center";
            }
          }

          // Body alignment
          if (data.section === "body") {
            if (data.column.index === 0) data.cell.styles.halign = "left";
            else if (data.column.index === lastHsnColIndex) data.cell.styles.halign = "right";
            else data.cell.styles.halign = "center";

            // Grand Total row styling
            if (data.row.index === processedHsnList.length - 1) {
              data.cell.styles.fontSize = 6;
              data.cell.styles.fontStyle = "bold";

              const taxColumnIndices = isIntraStateGST1 ? [2, 3] : [4];
              if (taxColumnIndices.includes(data.column.index)) {
                data.cell.styles.fontStyle = "normal";
              }

              if (data.column.index === 0) data.cell.styles.halign = "right";
            }
          }
        },

        didDrawCell: function (data) {
          const isLastRow = data.row.index === processedHsnList.length - 1 && data.section === "body";

          // Remove left border (first column)
          if (data.column.index === 0) {
            data.cell.styles.lineWidth = { top: 0.1, right: 0, bottom: 0.1, left: 0 };
          }

          // Remove right border (last column)
          if (data.column.index === lastHsnColIndex) {
            data.cell.styles.lineWidth = { top: 0.1, right: 0, bottom: 0.1, left: 0.1 };
          }

          // Ensure last row font reset
          if (isLastRow) {
            doc.setFont("helvetica", "normal");
          }
        },
      });


      sectionBottomY = doc.autoTable.previous.finalY;
    } else {
      sectionBottomY = y; // If no HSN table, use current y position
    }



    if (sectionBottomY + 80 > bottomBorder) {
      doc.addPage([595.28, 841.89]);
      sectionBottomY = topBorder;
      doc.setFont("helvetica", "normal");
      doc.setTextColor("#000");
      doc.setFontSize(7);
    }

    // ==================== BANK DETAILS (LEFT) + CERTIFICATION (RIGHT) ====================
    let sectionTopY = sectionBottomY;

    // Draw top horizontal line
    doc.line(leftMargin, sectionTopY, colX3, sectionTopY);

    // Center positions
    const centerX = (colX1 + colX3) / 2;
    const textWidth1 = colX3 - colX1;

    // === Wrap Client Name ===
    function wrapClientName(text, firstLimit = 30, otherLimit = 60) {
      if (!text) return [];
      let words = text.split(" ");
      let lines = [];
      let currentLine = "";
      let limit = firstLimit;

      words.forEach((word) => {
        if ((currentLine + word).length > limit) {
          lines.push(currentLine.trim());
          currentLine = word + " ";
          limit = otherLimit;
        } else {
          currentLine += word + " ";
        }
      });

      if (currentLine.trim()) lines.push(currentLine.trim());
      return lines;
    }

    const clientLines = wrapClientName((clientname || "").toUpperCase(), 30, 60);

    // === Certification text ===
    doc.setFont("helvetica", "normal").setFontSize(6);
    doc.text(
      "We certified that particulars given above are true and correct",
      centerX,
      sectionTopY + 10,
      { align: "center", maxWidth: textWidth1 - 20 }
    );

    // === Print "for CLIENTNAME" (wrapped) ===
    let cy = sectionTopY + 20;
    const lh = 8; // line height
    if (clientLines.length > 0) {
      // First line with "for " + part of name
      const firstPart = clientLines[0];
      const forText = "for ";
      const forWidth = doc.getTextWidth(forText);
      const firstWidth = doc.getTextWidth(firstPart);
      const totalWidth = forWidth + firstWidth;

      const startX = centerX - totalWidth / 2;

      doc.setFont("helvetica", "normal");
      doc.text(forText, startX, cy);

      doc.setFont("helvetica", "bold");
      doc.text(firstPart, startX + forWidth, cy);

      // Remaining lines (bold, centered)
      for (let i = 1; i < clientLines.length; i++) {
        cy += lh;
        doc.setFont("helvetica", "bold");
        doc.text(clientLines[i], centerX, cy, { align: "center" });
      }
    }

    // === Divider before Bank Details ===
    cy += lh - 5;
    doc.setFont("helvetica", "bold").setFontSize(7);
    doc.text("Bank Details", 25, cy - 5);
    doc.line(leftMargin, cy + 2, colX3, cy + 2);

    // === Bank details fields (LEFT) ===
    const bankFields = [
      { label: "Bank Name", value: this.state.bankdetails.bankname },
      { label: "Bank Acc No.", value: this.state.bankdetails.accno },
      { label: "Branch Name", value: this.state.bankdetails.branchname },
      { label: "IFSC", value: this.state.bankdetails.ifsc },
    ];

    let bankY = cy + 12;
    bankFields.forEach((field, index) => {
      const yPos = bankY + index * 12;
      doc.setFont("helvetica", "bold").setFontSize(7);
      doc.text(field.label, 25, yPos);
      doc.text("-", 80, yPos);
      doc.setFont("helvetica", "normal").setFontSize(7);
      doc.text(field.value || "", 90, yPos);
    });

    // === Certification right-bottom ===
    let rightY = cy + 30;
    doc.setFont("helvetica", "bold").setFontSize(6);
    doc.text("Authorised Signatory", centerX, rightY, {
      align: "center",
      maxWidth: textWidth1 - 20,
    });

    rightY += 10;
    doc.setFont("helvetica", "normal").setFontSize(6);
    doc.text("System generated invoice - no need for signature", centerX, rightY, {
      align: "center",
      maxWidth: textWidth1 - 20,
    });

    // === Final box height ===
    const lastBankFieldY = bankY + (bankFields.length - 1) * 12;
    const sectionEndY = Math.max(lastBankFieldY, rightY) + 5;

    // Middle divider
    doc.line(colX1, sectionTopY, colX1, sectionEndY);

    // Bottom border
    doc.line(leftMargin, sectionEndY, colX3, sectionEndY);

    // Update tracker
    sectionBottomY = sectionEndY;


    // ==================== TERMS AND CONDITIONS ====================
    y = sectionBottomY;

    if (y + 80 > bottomBorder) {
      doc.addPage([595.28, 841.89]);
      y = topBorder;
    }
    doc.setFontSize(7);
    doc.setFont("helvetica", "bold");
    doc.setTextColor('#000000');
    doc.text("Terms and Conditions :", leftMargin + 10, y + 15);
    doc.setFontSize(6);
    doc.setFont("helvetica", "normal");
    if (this.state.templete.terms) {
      const pageHeight = doc.internal.pageSize.height;
      const margin = 20;
      const lineHeight = 7;
      let yPos = y + 40; // start position

      // split text into lines that fit within width
      const splitTitle = doc.splitTextToSize(this.state.templete.terms, 500);

      splitTitle.forEach((line) => {
        if (yPos + lineHeight > pageHeight - margin - 20) {
          doc.addPage();        // add new page
          yPos = margin + 20;        // reset y position on new page
        }
        doc.text(line, 30, yPos);
        yPos += lineHeight;
      });
    }


    // ==================== FOOTER WITH PAGE NUMBERS ====================
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      const pageSize = doc.internal.pageSize;
      const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
      const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
      const footer = `Page ${i} of ${pageCount}`;

      // Page border
      doc.line(15, 25, colX3, 25);
      doc.line(15, pageHeight - 40, colX3, pageHeight - 40);
      doc.line(15, 25, 15, pageHeight - 40);
      doc.line(colX3, 25, colX3, pageHeight - 40);

      doc.setFontSize(8);
      doc.text(
        footer,
        pageWidth / 2 - doc.getTextWidth(footer) / 2,
        pageHeight - 25,
        { baseline: "bottom" }
      );
    }

    // ==================== SAVE PDF ====================
    doc.autoPrint({ variant: "non-conform" });
    doc.save(`${sodata.customqtid}.pdf`);
  }

  selectFile = (event) => {
    this.setState({
      selectedFiles: event.target.files,
      partyid: this.state.Order.custid,
    });
  };

  upload() {
    let currentFile = this.state.selectedFiles[0];

    this.setState({ progress: 100, currentFile: currentFile });

    UploadFilesService.upload(
      currentFile,
      year,
      curmonth,
      doctype,
      this.state.partyid,
      day
      // (event) => {
      //   this.setState({
      //     progress: Math.round((100 * event.loaded) / event.total),
      //   });
      //   progress = Math.round((100 * event.loaded) / event.total);
      // }
    )
      .then((response) => {
        this.setState({
          message: response.data.message,
          isError: false,
        });
        return FileServices.getFiles1(currentFile.name);
      })
      .then((files) => {
        this.setState({ fileInfos: files.data });
      })

      .catch(() => {
        this.setState({
          progress: 0,
          message: "Could not upload the file!",
          currentFile: undefined,
          isError: true,
        });
      });

    this.setState({ selectedFiles: undefined });
  }

  handleSendMail = () => {
    if (this.state.fileInfos.length === 0) {
      alert("Please Upload File");
    } else {
      let filedata = this.state.fileInfos.map((e) => e.name);
      path =
        prefix1 +
        "/" +
        doctype +
        "/" +
        this.state.partyid +
        "/" +
        year +
        "/" +
        curmonth +
        "/" +
        day;
      let data = {
        file: filedata.toLocaleString(),
        path: path,
        soid: this.state.id,
      };
      SalesServices.UploadPOfile(data)
        .then(() =>
          this.setState({
            show: false,
            selectedFiles: undefined,
            currentFile: undefined,
            progress: 0,
            message: "",
            isError: false,
            fileInfos: [],
            fileInfo: "",
            partyid: "",
            error: false,
          })
        )
        .catch((e) => {
          if (e.response.data.error === "Unauthorized") {
            alert("Your Session is Lost: Please login Back to resume");
            this.props.navigate(`/`);
          }
        });
    }
  };

  handleShowModal = () => {
    doctype = "pofile";
    this.setState({ showModal: true });
  };

  handleModalClose = () => {
    this.setState({ showModal: false });
  };

  handlesale = (e) => {
    this.setState({ salestype: e.target.value });
  };

  handleShow = () => {
    doctype = "somail";
    this.setState({ show: true });
  };

  handleClose = () => {
    this.setState({ show: false });
  };

  handleCancelModalShow = () => {
    this.setState({ showCancelModal: true });
  };

  handleCancelModalClose = () => {
    this.setState({ showCancelModal: false });
  };

  handleApprove = (stat) => {
    let statusdata = {
      id: this.state.id,
      status: stat,
      canceldesc: "",
      updatedby: userid,
    };
    Swal.fire({
      title: stat === 2 ? "Approve Quotation" : stat === 1 ? "Send Quotation to Revise" : "",
      text: "Are you sure you?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      confirmButtonColor: "#152f5f",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        SalesServices.UpdateQuotationStatus(statusdata)
          .then(() =>
            Swal.fire({
              title: stat === 2 ? "Quotation Approved Successfully" : stat === 1 ? "Quotation Sent for Revision" : "",
              text: "",
              icon: "success",
              showCancelButton: false,
              confirmButtonText: "Yes",
              confirmButtonColor: "#152f5f"
            }).then(() => this.refreshSalesorder())
          )
          .catch((e) => {
            if (e.response.data.error === "Unauthorized") {
              alert("Your Session is Lost: Please login Back to resume");
              this.props.navigate(`/`);
            }
          })
      }
    })
  }

  handleCancel = () => {
    this.setState({ stat: 2 }, () => {
      let statusdata = {
        id: this.state.id,
        status: this.state.stat,
        canceldesc: this.state.desc,
        updatedby: userid,
      };


      Swal.fire({
        title: "Terminate quotation?",
        text: "Are you sure you?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes",
        confirmButtonColor: "#152f5f",
        cancelButtonText: "No",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          SalesServices.TerminateQO(statusdata)
            .then(() =>
              Swal.fire({
                title: "Quotation successfully terminated",
                text: "",
                icon: "success",
                showCancelButton: false,
                confirmButtonText: "Yes",
                confirmButtonColor: "#152f5f"
              }).then(() => this.refreshSalesorder())
            )
            .catch((e) => {
              if (e.response.data.error === "Unauthorized") {
                alert("Your Session is Lost: Please login Back to resume");
                this.props.navigate(`/`);
              }
            })
        }
      })


    });
  };

  handleFinalSubmit = () => {
    if (this.state.fileInfos.length === 0) {
      this.setState({ message: "Please Upload PO file" });
      alert("Please Upload PO file");
    } else {
      let filedata = this.state.fileInfos.map((e) => e.name);
      path =
        prefix1 +
        "/" +
        doctype +
        "/" +
        this.state.partyid +
        "/" +
        this.state.id +
        "/" +
        year +
        "/" +
        curmonth +
        "/" +
        day;
      let uploaddata = {
        file: filedata.toLocaleString(),
        path: path,
        soid: this.state.id,
        poid: this.state.poid,
        amount: parseFloat(this.state.amount),
      };
      SalesServices.UploadPOfile(uploaddata)
        .then((res) =>
          this.setState(
            {
              pofile: res.data.file,
              popath: res.data.path,
              selectedFiles: undefined,
              currentFile: undefined,
              progress: 0,
              message: "",
              isError: false,
              fileInfos: [],
              fileInfo: "",
              error: false,
              errorMessage: {},
            },
            () => this.handleModalClose()
          )
        )
        .catch((e) => {
          if (e.response.data.error === "Unauthorized") {
            alert("Your Session is Lost: Please login Back to resume");
            this.props.navigate(`/`);
          }
        });
    }
  };

  refreshSalesorder() {
    const { id } = this.props.location.state;

    SalesServices.GetQuotationbyId(id).then((resp) => {
      this.setState({
        Order: resp.data,
        saleorderitems: resp.data.itemquotation,
        serviceList: resp.data.servicequotation,
        sostatus: resp.data.sostatus,
        status: resp.data.qtstatus,
        milestones:
          resp.data.servicequotation.length !== 0
            ? resp.data.servicequotation.find((e) => e).milestonequotation
            : [],
        pofile: resp.data.pofile,
        popath: resp.data.popath,
        amount: resp.data.sototalwtax,
        loading: false
      });
    });
    //   .catch((e)=>{
    //     if(e.response.data.error ==="Unauthorized"){
    //         alert("Your Session is Lost: Please login Back to resume");
    //         this.props.navigate(`/`);
    //     }
    // })
    let data = "Quotation";
    SettingsServices.GetActivePdfTemplate(data, currentTenant).then(
      (response) => this.setState({ templete: response.data })
    );

    BankServices.getActivebank(currentTenant).then((res) =>
      this.setState({ bankdetails: res.data })
    );
  }

  onfocus() {
    document
      .getElementById("amount")
      .addEventListener("mousewheel", function (event) {
        if (window.document.activeElement.type === "number") {
          event.preventDefault();
        }
      });
    document.getElementById("amount").addEventListener("keydown", function (e) {
      if (e.which === 38 || e.which === 40) {
        e.preventDefault();
      }
    });
  }

  componentDidMount() {
    if (userid === undefined) {
      window.confirm("Your Session is Lost: Please login Back to resume");
      this.props.navigate(`/`);
    }
    this.setState({ loading: true });
    this.refreshSalesorder();

    year = new Date().getFullYear();
    day = new Date().getDate();
    let mn = new Date().getMonth() + 1;
    curmonth = moment(mn, "M").format("MMMM");
    // if (this.state.status === "Confirmed") {
    //   this.setState({ stat: 1 });
    // } else {
    //   this.setState({ stat: 0 });
    // }
  }

  handledownload = () => {
    downloadfiles.download(this.state.popath, this.state.pofile);
  };

  render() {
    let { selectedFiles, message, isError } = this.state;

    // Render detail view for a selected product with sidebar
    const renderProductDetailView = () => {
      if (!this.state.activeProductDetail) return null;
      const product = this.state.activeProductDetail;
      return (
        <div style={this.styles.detailView}>
          <div style={this.styles.detailViewHeader}>
            <button
              style={{
                ...this.styles.backButton,
                backgroundColor: this.state.hoveredBtn === "back" ? "#4d4d4d" : this.styles.backButton.backgroundColor,
                color: this.state.hoveredBtn === "back" ? "#ffff" : "#4d4d4d",
                transform: this.state.hoveredBtn === "back" ? "scale(1.03)" : "scale(1)",
                transition: "all 0.01s ease",
              }}
              onClick={() => this.handleBackToTable("product")}
              onMouseEnter={() => this.setState({ hoveredBtn: "back" })}
              onMouseLeave={() => this.setState({ hoveredBtn: null })}
            >
              <i className="fa fa-arrow-left" /> All Products
            </button>

            <h3 style={{ margin: 0, color: '#1e293b' }}>Product Details</h3>
          </div>

          <div style={{ display: 'flex' }}>
            {/* Sidebar with product list */}
            <div style={this.styles.sidebar}>
              {this.state.saleorderitems.map((item, index) => {
                const isHovered = this.state.hoveredSidebar === item.id;
                const isActive = item.id === product.id;

                return (
                  <div
                    key={index}
                    style={{
                      ...this.styles.sidebarItem,
                      ...(isActive && this.styles.sidebarItemActive),
                      color: isHovered || isActive ? "#5f8f3f" : this.styles.sidebarItem.color,
                      transform: isHovered ? "scale(1.09)" : "scale(1)",
                      transition: "color 0.03s ease, transform 0.03s ease",
                      borderRadius: isHovered ? "6px" : "0",
                      cursor: "pointer",
                      fontWeight: isActive ? "bold" : "normal",
                    }}
                    onMouseEnter={() => this.setState({ hoveredSidebar: item.id })}
                    onMouseLeave={() => this.setState({ hoveredSidebar: null })}
                    onClick={() => this.handleItemDetail(item, "product")}
                  >
                    <div style={this.styles.sidebarItemName}>{item.name}</div>
                    <div style={this.styles.sidebarItemDetails}>
                      Qty: {item.quantity} {item.uom} |{" "}
                      Total:{" "}
                      <span style={{ fontWeight: "bold" }}>
                        <NumericFormat
                          displayType={"text"}
                          value={item.totalpricewtax}
                          decimalScale={2}
                          fixedDecimalScale={true}
                          thousandSeparator={true}
                          thousandsGroupStyle={thousandsdisplay}
                          prefix={currency === "INR" ? "₹" : currency === "USD" ? "$" : currency}
                        />
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>


            {/* Main content */}
            <div style={this.styles.detailContent}>
              <div style={this.styles.detailGrid}>
                <div style={this.styles.detailSection}>
                  <h4 style={this.styles.sectionTitle}>Basic Information</h4>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Name</span>
                    <span
                      style={{
                        ...this.styles.detailValue,
                        wordBreak: "break-word",
                        overflowWrap: "anywhere",
                        whiteSpace: "pre-wrap",
                        maxWidth: "300px",
                        marginLeft: "3px",
                      }}
                    >
                      {product.name}
                    </span>
                  </div>

                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Description</span>
                    <span
                      style={{
                        ...this.styles.detailValue,
                        wordBreak: "break-word",
                        overflowWrap: "anywhere",
                        whiteSpace: "pre-wrap",
                        maxWidth: "300px",
                        marginLeft: "3px",

                      }}
                    >
                      {product.description || "N/A"}
                    </span>
                  </div>

                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>HSN Code</span>
                    <span style={this.styles.detailValue}>{product.hsn || 'N/A'}</span>
                  </div>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Quantity</span>
                    <span style={this.styles.detailValue}>{product.quantity} {product.uom}</span>
                  </div>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Sales Type</span>
                    <span style={this.styles.detailValue}>{product.salesenum}</span>
                  </div>
                </div>

                <div style={this.styles.detailSection}>
                  <h4 style={this.styles.sectionTitle}>Pricing</h4>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Unit Price</span>
                    <span style={{ ...this.styles.detailValue, fontWeight: "" }}>
                      <NumericFormat
                        displayType={"text"}
                        value={product.price}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        thousandsGroupStyle={thousandsdisplay}
                        prefix={currency === "INR" ? "₹" : currency === "USD" ? "$" : currency}
                      />
                    </span>
                    {this.state.Order.currency !== currency && <span style={{ ...this.styles.detailValue, fontWeight: "" }}>
                      <NumericFormat
                        displayType={"text"}
                        value={product.ccprice}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        thousandsGroupStyle={thousandsdisplay}
                        prefix={this.state.Order.currency === "INR" ? "₹" : this.state.Order.currency === "USD" ? "$" : this.state.Order.currency}
                      />
                    </span>}
                  </div>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Total Price</span>
                    <span style={{ ...this.styles.detailValue, fontWeight: "" }}>
                      <NumericFormat
                        displayType={"text"}
                        value={product.totalprice}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        thousandsGroupStyle={thousandsdisplay}
                        prefix={currency === "INR" ? "₹" : currency === "USD" ? "$" : currency}
                      />
                    </span>
                    {this.state.Order.currency !== currency && <span style={{ ...this.styles.detailValue, fontWeight: "" }}>
                      <NumericFormat
                        displayType={"text"}
                        value={product.cctotalprice}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        thousandsGroupStyle={thousandsdisplay}
                        prefix={this.state.Order.currency === "INR" ? "₹" : this.state.Order.currency === "USD" ? "$" : this.state.Order.currency}
                      />
                    </span>}
                  </div>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Tax ({product.tax}%)</span>
                    <span style={{ ...this.styles.detailValue, fontWeight: "" }}>
                      <NumericFormat
                        displayType={"text"}
                        value={product.taxamount}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        thousandsGroupStyle={thousandsdisplay}
                        prefix={currency === "INR" ? "₹" : currency === "USD" ? "$" : currency}
                      />
                    </span>
                    {this.state.Order.currency !== currency && <span style={{ ...this.styles.detailValue, fontWeight: "" }}>
                      <NumericFormat
                        displayType={"text"}
                        value={product.cctaxamount}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        thousandsGroupStyle={thousandsdisplay}
                        prefix={this.state.Order.currency === "INR" ? "₹" : this.state.Order.currency === "USD" ? "$" : this.state.Order.currency}
                      />
                    </span>}
                  </div>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Total with Tax</span>
                    <span style={{ ...this.styles.detailValue, fontWeight: "bold" }}>
                      <NumericFormat
                        displayType={"text"}
                        value={product.totalpricewtax}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        thousandsGroupStyle={thousandsdisplay}
                        prefix={currency === "INR" ? "₹" : currency === "USD" ? "$" : currency}
                      />
                    </span>
                    {this.state.Order.currency !== currency && <span style={{ ...this.styles.detailValue, fontWeight: "bold" }}>
                      <NumericFormat
                        displayType={"text"}
                        value={product.cctotalpricewtax}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        thousandsGroupStyle={thousandsdisplay}
                        prefix={this.state.Order.currency === "INR" ? "₹" : this.state.Order.currency === "USD" ? "$" : this.state.Order.currency}
                      />
                    </span>}
                  </div>
                </div>

                <div style={this.styles.detailSection}>
                  <h4 style={this.styles.sectionTitle}>Additional Details</h4>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Brand</span>
                    <span style={this.styles.detailValue}>{product.brand || 'N/A'}</span>
                  </div>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Model</span>
                    <span style={this.styles.detailValue}>{product.model || 'N/A'}</span>
                  </div>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Color</span>
                    <span style={this.styles.detailValue}>{product.colour || 'N/A'}</span>
                  </div>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Size</span>
                    <span style={this.styles.detailValue}>{product.size || 'N/A'}</span>
                  </div>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Thickness</span>
                    <span style={this.styles.detailValue}>{product.thickness || 'N/A'}</span>
                  </div>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Total Mtr/Roll</span>
                    <span style={this.styles.detailValue}>{product.totalmtrroll || 'N/A'}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    };

    // Render detail view for a selected service with sidebar
    const renderServiceDetailView = () => {
      if (!this.state.activeServiceDetail) return null;

      const service = this.state.activeServiceDetail;

      return (
        <div style={this.styles.detailView}>
          <div style={this.styles.detailViewHeader}>
            <button
              style={{
                ...this.styles.backButton,
                backgroundColor: this.state.hoveredBtn === "back-service" ? "#4d4d4d" : this.styles.backButton.backgroundColor,
                color: this.state.hoveredBtn === "back-service" ? "#fff" : "#4d4d4d",
                transform: this.state.hoveredBtn === "back-service" ? "scale(1.03)" : "scale(1)",
                transition: "all 0.01s ease",
              }}
              onClick={() => this.handleBackToTable("service")}
              onMouseEnter={() => this.setState({ hoveredBtn: "back-service" })}
              onMouseLeave={() => this.setState({ hoveredBtn: null })}
            >
              <i className="fa fa-arrow-left" /> All Services
            </button>

            <h3 style={{ margin: 0, color: '#1e293b' }}>Service Details</h3>
          </div>

          <div style={{ display: 'flex' }}>
            {/* Sidebar with service list */}
            <div style={this.styles.sidebar}>
              {this.state.serviceList.map((item, index) => {
                const isHovered = this.state.hoveredService === item.id;
                const isActive = item.id === service.id;

                return (
                  <div
                    key={index}
                    style={{
                      ...this.styles.sidebarItem,
                      ...(isActive && this.styles.sidebarItemActive),
                      color: isHovered || isActive ? "#5f8f3f" : this.styles.sidebarItem.color,
                      transform: isHovered ? "scale(1.09)" : "scale(1)",
                      transition: "color 0.03s ease, transform 0.03s ease",
                      borderRadius: isHovered ? "6px" : "0",
                      cursor: "pointer",
                      fontWeight: isActive ? "bold" : "normal",
                    }}
                    onMouseEnter={() => this.setState({ hoveredService: item.id })}
                    onMouseLeave={() => this.setState({ hoveredService: null })}
                    onClick={() => this.handleItemDetail(item, "service")}
                  >
                    <div style={this.styles.sidebarItemName}>{item.service}</div>
                    <div style={this.styles.sidebarItemDetails}>
                      Total:{" "}
                      <span style={{ fontWeight: "bold" }}>
                        <NumericFormat
                          displayType={"text"}
                          value={item.servicetotalwtax}
                          decimalScale={2}
                          fixedDecimalScale={true}
                          thousandSeparator={true}
                          thousandsGroupStyle={thousandsdisplay}
                          prefix={currency === "INR" ? "₹" : currency === "USD" ? "$" : currency}
                        />
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>


            {/* Main content */}
            <div style={this.styles.detailContent}>
              <div style={this.styles.detailGrid}>
                <div style={this.styles.detailSection}>
                  <h4 style={this.styles.sectionTitle}>Service Information</h4>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Service</span>
                    <span style={{
                      ...this.styles.detailValue, wordBreak: "break-word",
                      overflowWrap: "anywhere",
                      whiteSpace: "pre-wrap",
                      maxWidth: "300px",
                      marginLeft: "3px"
                    }}>{service.service}</span>
                  </div>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Description</span>
                    <span style={{
                      ...this.styles.detailValue,
                      wordBreak: "break-word",
                      overflowWrap: "anywhere",
                      whiteSpace: "pre-wrap",
                      maxWidth: "300px",
                      marginLeft: "3px"
                    }}>{service.description || 'N/A'}</span>
                  </div>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Service Code</span>
                    <span style={this.styles.detailValue}>{service.servicecode || 'N/A'}</span>
                  </div>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Contract Type</span>
                    <span style={this.styles.detailValue}>{service.contracttype}</span>
                  </div>
                  {service.contracttype === 'Recurring' && (
                    <>
                      <div style={this.styles.detailRow}>
                        <span style={this.styles.detailLabel}>Recurring Type</span>
                        <span style={this.styles.detailValue}>{service.recurringtype}</span>
                      </div>
                      <div style={this.styles.detailRow}>
                        <span style={this.styles.detailLabel}>Recurring End Date</span>
                        <span style={this.styles.detailValue}>
                          {moment(service.recurrencetill).format("DD MMM YYYY")}
                        </span>
                      </div>
                    </>
                  )}
                </div>

                <div style={this.styles.detailSection}>
                  <h4 style={this.styles.sectionTitle}>Pricing</h4>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Service Cost</span>
                    <span style={{ ...this.styles.detailValue, fontWeight: "" }}>
                      <NumericFormat
                        displayType={"text"}
                        value={service.servicecost + service.markup1}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        thousandsGroupStyle={thousandsdisplay}
                        prefix={currency === "INR" ? "₹" : currency === "USD" ? "$" : currency}
                      />
                    </span>
                    {this.state.Order.currency !== currency &&
                      <span style={{ ...this.styles.detailValue, fontWeight: "" }}>
                        <NumericFormat
                          displayType={"text"}
                          value={service.ccservicecost + service.ccmarkup1}
                          decimalScale={2}
                          fixedDecimalScale={true}
                          thousandSeparator={true}
                          thousandsGroupStyle={thousandsdisplay}
                          prefix={this.state.Order.currency === "INR" ? "₹" : this.state.Order.currency === "USD" ? "$" : this.state.Order.currency}
                        />
                      </span>}
                  </div>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Discount ({service.servicediscount}%)</span>
                    <span style={{ ...this.styles.detailValue, fontWeight: "" }}>
                      <NumericFormat
                        displayType={"text"}
                        value={service.servicediscountamount ? -service.servicediscountamount : 0}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        thousandsGroupStyle={thousandsdisplay}
                        prefix={currency === "INR" ? "₹" : currency === "USD" ? "$" : currency}
                      />
                    </span>
                    {this.state.Order.currency !== currency &&
                      <span style={{ ...this.styles.detailValue, fontWeight: "" }}>
                        <NumericFormat
                          displayType={"text"}
                          value={service.ccservicediscountamount ? -service.ccservicediscountamount : 0}
                          decimalScale={2}
                          fixedDecimalScale={true}
                          thousandSeparator={true}
                          thousandsGroupStyle={thousandsdisplay}
                          prefix={this.state.Order.currency === "INR" ? "₹" : this.state.Order.currency === "USD" ? "$" : this.state.Order.currency}
                        />
                      </span>}
                  </div>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Tax ({service.servicetax}%)</span>
                    <span style={{ ...this.styles.detailValue, fontWeight: "" }}>
                      <NumericFormat
                        displayType={"text"}
                        value={service.servicetaxamount ? service.servicetaxamount : service.servicetotalwtax - service.servicecost}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        thousandsGroupStyle={thousandsdisplay}
                        prefix={currency === "INR" ? "₹" : currency === "USD" ? "$" : currency}
                      />
                    </span>
                    {this.state.Order.currency !== currency &&
                      <span style={{ ...this.styles.detailValue, fontWeight: "" }}>
                        <NumericFormat
                          displayType={"text"}
                          value={service.ccservicetaxamount ? service.ccservicetaxamount : service.ccservicetotalwtax - service.ccservicecost}
                          decimalScale={2}
                          fixedDecimalScale={true}
                          thousandSeparator={true}
                          thousandsGroupStyle={thousandsdisplay}
                          prefix={this.state.Order.currency === "INR" ? "₹" : this.state.Order.currency === "USD" ? "$" : this.state.Order.currency}
                        />
                      </span>}
                  </div>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Total with Tax</span>
                    <span style={{ ...this.styles.detailValue, fontWeight: "bold" }}>
                      <NumericFormat
                        displayType={"text"}
                        value={service.servicetotalwtax}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        thousandsGroupStyle={thousandsdisplay}
                        prefix={currency === "INR" ? "₹" : currency === "USD" ? "$" : currency}
                      />
                    </span>
                    {this.state.Order.currency !== currency &&
                      <span style={{ ...this.styles.detailValue, fontWeight: "bold" }}>
                        <NumericFormat
                          displayType={"text"}
                          value={service.ccservicetotalwtax}
                          decimalScale={2}
                          fixedDecimalScale={true}
                          thousandSeparator={true}
                          thousandsGroupStyle={thousandsdisplay}
                          prefix={this.state.Order.currency === "INR" ? "₹" : this.state.Order.currency === "USD" ? "$" : this.state.Order.currency}
                        />
                      </span>}
                  </div>
                </div>

                {/* {service.milestonequotation && service.milestonequotation.length > 0 && (
                <div style={this.styles.detailSection}>
                  <h4 style={this.styles.sectionTitle}>Milestones</h4>
                  {service.milestonequotation.map((milestone, idx) => (
                    <div key={idx} style={{ marginBottom: '16px', padding: '12px', backgroundColor: '#ffffff', borderRadius: '6px', border: '1px solid #e2e8f0' }}>
                      <div style={this.styles.detailRow}>
                        <span style={this.styles.detailLabel}>Name</span>
                        <span style={this.styles.detailValue}>{milestone.name}</span>
                      </div>
                      <div style={this.styles.detailRow}>
                        <span style={this.styles.detailLabel}>Expected Date</span>
                        <span style={this.styles.detailValue}>
                          {moment(milestone.expecteddate).format("DD MMM YYYY")}
                        </span>
                      </div>
                      <div style={this.styles.detailRow}>
                        <span style={this.styles.detailLabel}>Percentage</span>
                        <span style={this.styles.detailValue}>{milestone.percentage}%</span>
                      </div>
                      <div style={this.styles.detailRow}>
                        <span style={this.styles.detailLabel}>Amount</span>
                        <span style={this.styles.detailValue}>
                          <NumericFormat
                            displayType={"text"}
                            value={milestone.amount}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            thousandSeparator={true}
                            thousandsGroupStyle={thousandsdisplay}
                            prefix={currency==="INR"?"₹":currency==="USD"?"$":currency}
                          />
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              )} */}
              </div>
            </div>
          </div>
        </div>
      );
    };

    // Render detail view for a selected milestone with sidebar
    const renderMilestoneDetailView = () => {
      if (!this.state.activeMilestoneDetail) return null;

      const milestone = this.state.activeMilestoneDetail;

      return (
        <div style={this.styles.detailView}>

          <div style={this.styles.detailViewHeader}>
            <button
              style={{
                ...this.styles.backButton,
                backgroundColor: this.state.hoveredBtn === "back-milestone" ? "#4d4d4d" : this.styles.backButton.backgroundColor,
                color: this.state.hoveredBtn === "back-milestone" ? "#fff" : "#4d4d4d",
                transform: this.state.hoveredBtn === "back-milestone" ? "scale(1.03)" : "scale(1)",
                transition: "all 0.01s ease",
              }}
              onClick={() => this.handleBackToTable("milestone")}
              onMouseEnter={() => this.setState({ hoveredBtn: "back-milestone" })}
              onMouseLeave={() => this.setState({ hoveredBtn: null })}
            >
              <i className="fa fa-arrow-left" /> All Milestones
            </button>

            <h3 style={{ margin: 0, color: '#1e293b' }}>Milestone Details</h3>
          </div>

          <div style={{ display: 'flex' }}>
            {/* Sidebar with milestone list */}
            <div style={this.styles.sidebar}>
              {this.state.milestones.map((item, index) => {
                const isHovered = this.state.hoveredMilestone === item.id;
                const isActive = item.id === milestone.id;

                return (
                  <div
                    key={index}
                    style={{
                      ...this.styles.sidebarItem,
                      ...(isActive && this.styles.sidebarItemActive),
                      color: isHovered || isActive ? "#5f8f3f" : this.styles.sidebarItem.color,
                      transform: isHovered ? "scale(1.09)" : "scale(1)",
                      transition: "color 0.03s ease, transform 0.03s ease",
                      borderRadius: isHovered ? "6px" : "0",
                      cursor: "pointer",
                      fontWeight: isActive ? "bold" : "normal",
                    }}
                    onMouseEnter={() => this.setState({ hoveredMilestone: item.id })}
                    onMouseLeave={() => this.setState({ hoveredMilestone: null })}
                    onClick={() => this.handleItemDetail(item, "milestone")}
                  >
                    <div style={this.styles.sidebarItemName}>{item.name}</div>
                    <div style={this.styles.sidebarItemDetails}>
                      Due: {moment(item.expecteddate).format("DD MMM")} | Amount:{" "}
                      <span style={{ fontWeight: "bold" }}>
                        <NumericFormat
                          displayType={"text"}
                          value={item.amount}
                          decimalScale={2}
                          fixedDecimalScale={true}
                          thousandSeparator={true}
                          thousandsGroupStyle={thousandsdisplay}
                          prefix={currency === "INR" ? "₹" : currency === "USD" ? "$" : currency}
                        />
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>


            {/* Main content */}
            <div style={this.styles.detailContent}>
              <div style={this.styles.detailGrid}>
                <div style={this.styles.detailSection}>
                  <h4 style={this.styles.sectionTitle}>Milestone Information</h4>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Name</span>
                    <span style={this.styles.detailValue}>{milestone.name}</span>
                  </div>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Expected Date</span>
                    <span style={this.styles.detailValue}>
                      {moment(milestone.expecteddate).format("DD MMM YYYY")}
                    </span>
                  </div>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Percentage</span>
                    <span style={this.styles.detailValue}>{milestone.percentage}%</span>
                  </div>
                </div>

                <div style={this.styles.detailSection}>
                  <h4 style={this.styles.sectionTitle}>Pricing</h4>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Amount</span>
                    <span style={{ ...this.styles.detailValue, fontWeight: "" }}>
                      <NumericFormat
                        displayType={"text"}
                        value={milestone.amount}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        thousandsGroupStyle={thousandsdisplay}
                        prefix={currency === "INR" ? "₹" : currency === "USD" ? "$" : currency}
                      />
                    </span>
                  </div>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Tax Amount</span>
                    <span style={{ ...this.styles.detailValue, fontWeight: "" }}>
                      <NumericFormat
                        displayType={"text"}
                        value={milestone.taxamount}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        thousandsGroupStyle={thousandsdisplay}
                        prefix={currency === "INR" ? "₹" : currency === "USD" ? "$" : currency}
                      />
                    </span>
                  </div>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Total with Tax</span>
                    <span style={{ ...this.styles.detailValue, fontWeight: "bold" }}>
                      <NumericFormat
                        displayType={"text"}
                        value={milestone.amountwttax}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        thousandsGroupStyle={thousandsdisplay}
                        prefix={currency === "INR" ? "₹" : currency === "USD" ? "$" : currency}
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    };

    return (
      <div className="UI-container">
        <div className="UI-header">
          <Breadcrumb breadcrumbs={[{ name: "Home", path: "/sales" }, { name: "Quotations", path: "/quotation" }, { name: "Quotation Details", path: null }]} />
          <div style={this.styles.headerContent}>
            <div>
              <h1 style={this.styles.title}>
                Quotation Details
              </h1>
              <p style={this.styles.subtitle}>
                ID: {this.state.Order.customqtid || 'Loading...'}
              </p>
            </div>

            <div style={this.styles.headerActions}>
              {(salesid === "3" || salesid === "2") && this.state.status === "ACTIVE" && (this.state.Order.status === "Approved" || this.state.Order.status === "SelfApproved") ? <>
                <button
                  style={{
                    ...this.styles.btn,
                    ...this.styles.btnOutline,
                    backgroundColor: this.state.hoveredBtn === "email" ? "#4d4d4d" : "#fff",
                    color: this.state.hoveredBtn === "email" ? "#fff" : "#4d4d4d",
                    transform: this.state.hoveredBtn === "email" ? "scale(1.03)" : "scale(1)",
                    transition: "all 0.01s ease",
                  }}
                  onMouseEnter={() => this.setState({ hoveredBtn: "email" })}
                  onMouseLeave={() => this.setState({ hoveredBtn: null })}
                  onClick={() => this.handleShow()}
                >
                  <i className="fa fa-envelope" /> Email
                </button>

                <button
                  style={{
                    ...this.styles.btn,
                    ...this.styles.btnOutline,
                    backgroundColor: this.state.hoveredBtn === "pdf" ? "#4d4d4d" : "#fff",
                    color: this.state.hoveredBtn === "pdf" ? "#fff" : "#4d4d4d",
                    transform: this.state.hoveredBtn === "pdf" ? "scale(1.03)" : "scale(1)",
                    transition: "all 0.01s ease",
                  }}
                  onMouseEnter={() => this.setState({ hoveredBtn: "pdf" })}
                  onMouseLeave={() => this.setState({ hoveredBtn: null })}
                  onClick={() => this.handlepdfDownload(this.state.Order)}
                >
                  <i className="fa fa-file-pdf" /> PDF
                </button>

              </> : ""}

              {(salesid === "3" || salesid === "2") && this.state.status !== "CLOSED" ? (
                <>
                  {this.state.status === "COMPLETED" ? (
                    <Link
                      style={{ ...this.styles.btn, ...this.styles.btnPrimary }}
                      to={{ pathname: "/saleorderdetails" }}
                      state={{ id: this.state.Order.soid, bvstatus: 0, qid: this.state.id }}
                    >
                      Show Order
                    </Link>
                  ) : (
                    <>
                      {this.state.Order.status !== "SelfApproved" && this.state.Order.status !== "Approved" ? <>
                        {this.state.Order.status !== "Revise" ? <>
                          <button
                            style={{
                              ...this.styles.btn,
                              ...this.styles.btnPrimary,
                              color: this.state.hoveredBtn === "Approve" ? this.styles.btnPrimary.color : this.styles.btnPrimary.color, // 🔥 only text color changes
                              transform: this.state.hoveredBtn === "Approve" ? "scale(1.03)" : "scale(1)",
                              transition: "all 0.01s ease",
                            }}

                            onMouseEnter={() => this.setState({ hoveredBtn: "Approve" })}
                            onMouseLeave={() => this.setState({ hoveredBtn: null })}
                            onClick={() => this.handleApprove(3)}
                          >
                            <i className="fa fa-check" /> Approve
                          </button>
                          <button
                            style={{
                              ...this.styles.btn,
                              ...this.styles.btnPrimary,
                              color: this.state.hoveredBtn === "Revise" ? this.styles.btnPrimary.color : this.styles.btnPrimary.color, // 🔥 only text color changes
                              transform: this.state.hoveredBtn === "Revise" ? "scale(1.03)" : "scale(1)",
                              transition: "all 0.01s ease",
                            }}

                            onMouseEnter={() => this.setState({ hoveredBtn: "Revise" })}
                            onMouseLeave={() => this.setState({ hoveredBtn: null })}
                            onClick={() => this.handleApprove(1)}
                          >
                            <i className="fa fa-rotate-right" /> Revise
                          </button>
                        </> : ""}
                        <Link
                          style={{
                            ...this.styles.btn,
                            ...this.styles.btnOutline,
                            backgroundColor: this.state.hoveredBtn === "edit" ? "#4d4d4d" : "#fff",
                            color: this.state.hoveredBtn === "edit" ? "#fff" : "#4d4d4d",
                            transform: this.state.hoveredBtn === "edit" ? "scale(1.03)" : "scale(1)",
                            transition: "all 0.01s ease",
                          }}
                          to={{ pathname: `/newquotation` }}
                          state={{
                            pagename: "Edit/Updated Quotation",
                            id: this.state.id,
                          }}
                          onMouseEnter={() => this.setState({ hoveredBtn: "edit" })}
                          onMouseLeave={() => this.setState({ hoveredBtn: null })}
                        >
                          <i className="fa fa-pen" /> Edit
                        </Link>

                      </> :
                        this.state.Order.status === "SelfApproved" ?
                          <button
                            style={{
                              ...this.styles.btn,
                              ...this.styles.btnPrimary,
                              color: this.state.hoveredBtn === "Approve" ? this.styles.btnPrimary.color : this.styles.btnPrimary.color, // 🔥 only text color changes
                              transform: this.state.hoveredBtn === "Approve" ? "scale(1.03)" : "scale(1)",
                              transition: "all 0.01s ease",
                            }}

                            onMouseEnter={() => this.setState({ hoveredBtn: "Approve" })}
                            onMouseLeave={() => this.setState({ hoveredBtn: null })}
                            onClick={() => this.handleApprove(2)}
                          >
                            <i className="fa fa-check" />Customer Approve
                          </button>
                          : <Link
                            style={{
                              ...this.styles.btn,
                              ...this.styles.btnPrimary,
                              color: this.state.hoveredBtn === "createSO" ? this.styles.btnPrimary.color : this.styles.btnPrimary.color, // 🔥 only text color changes
                              transform: this.state.hoveredBtn === "createSO" ? "scale(1.03)" : "scale(1)",
                              transition: "all 0.01s ease",
                            }}
                            to={{ pathname: `/newsalesorder` }}
                            state={{
                              id: -1,
                              pagename: "New Order",
                              salestype: false,
                              orderfrom: 1,
                              qid: this.state.id,
                            }}
                            onMouseEnter={() => this.setState({ hoveredBtn: "createSO" })}
                            onMouseLeave={() => this.setState({ hoveredBtn: null })}
                          >
                            <i className="fa fa-plus" /> Create SO
                          </Link>

                      }
                      <button
                        style={{
                          ...this.styles.btn,
                          ...this.styles.btnDanger,
                          ...(this.state.hoveredBtn === "Terminate" ? this.styles.hoveredBtnDanger : {})
                        }}
                        onClick={() => this.handleCancelModalShow()}
                        onMouseEnter={() => this.setState({ hoveredBtn: "Terminate" })}
                        onMouseLeave={() => this.setState({ hoveredBtn: null })}
                      >
                        <i className="fa fa-times" /> Terminate
                      </button>

                    </>
                  )}
                </>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        <div className="UI-form-card">
          {this.state.Order.currency === currency && this.state.showCurrencyNote !== false && (
            <div
              style={{
                background: 'linear-gradient(90deg, #ecfdf5 0%, #f0fdf4 100%)',
                border: '1px solid #aff3c8ff',
                // borderLeft: '2px solid #86efac',
                borderRadius: '8px',
                padding: '2px 15px',
                margin: '2px 20px',
                fontSize: '0.9rem',
                color: '#166534',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                {/* <span style={{ fontSize: '1rem' }}>💱</span> */}
                <span style={{ fontWeight: '500' }}>
                  All Prices are in <b>{this.state.Order.currency}</b>.
                </span>
              </div>
              <button
                onClick={() => this.setState({ showCurrencyNote: false })}
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: '#166534',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  fontSize: '1rem',
                  lineHeight: '1'
                }}
              >
                ✕
              </button>
            </div>
          )}

          {this.state.loading === true ? (
            <div style={this.styles.loadingContainer}>
              {spin}
            </div>
          ) : (
            <div style={{ padding: '20px' }}>
              {/* Customer and Order Details */}
              <div style={this.styles.detailGrid}>
                <div style={this.styles.detailSection}>
                  <h3 style={this.styles.sectionTitle}>Customer Information</h3>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Customer</span>
                    <span style={{ ...this.styles.detailValue, maxWidth: "400px" }}>{this.state.Order.customer}</span>
                  </div>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Address</span>
                    <span style={{ ...this.styles.detailValue, maxWidth: "400px" }}>{this.state.Order.custaddress}</span>
                  </div>
                  {this.state.Order.custaddress2 && (
                    <div style={this.styles.detailRow}>
                      <span style={this.styles.detailLabel}>Address 2</span>
                      <span style={{ ...this.styles.detailValue, maxWidth: "400px" }}>{this.state.Order.custaddress2}</span>
                    </div>
                  )}
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>City/State/Country</span>
                    <span style={{ ...this.styles.detailValue, maxWidth: "400px" }}>
                      {this.state.Order.custcityname}, {this.state.Order.custstatename}, {this.state.Order.custcountryname} - {this.state.Order.custzip}
                    </span>
                  </div>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Created By</span>
                    <span style={{ ...this.styles.detailValue, maxWidth: "400px" }}>{this.state.Order.createdbyname}</span>
                  </div>
                  {this.state.Order.agent && (
                    <div style={this.styles.detailRow}>
                      <span style={this.styles.detailLabel}>Agent</span>
                      <span style={{ ...this.styles.detailValue, maxWidth: "400px" }}>{this.state.Order.agent}</span>
                    </div>
                  )}
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Date</span>
                    <span style={{ ...this.styles.detailValue, maxWidth: "400px" }}>
                      {moment(this.state.Order.createdAt).format("DD-MM-YYYY HH:MM")}
                    </span>
                  </div>
                </div>

                <div style={this.styles.detailSection}>
                  <h3 style={this.styles.sectionTitle}>Quotation Details</h3>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Tax Type</span>
                    <span style={{ ...this.styles.detailValue, maxWidth: "400px" }}>
                      {this.state.Order.taxtype} {this.state.Order.taxtype === "GST" && ccountry === "India" ? `(${this.state.Order.gsttype})` : ""}
                    </span>
                  </div>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Total Amount </span>
                    <span style={{ ...this.styles.detailValue, fontWeight: "bold" }}>
                      {currency}&nbsp;
                      <NumericFormat
                        displayType={"text"}
                        value={this.state.Order.sototalwtax}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        disabled={true}
                        thousandSeparator={true}
                        thousandsGroupStyle={thousandsdisplay}
                      />
                    </span>
                  </div>
                  {this.state.Order.currency !== currency && (
                    <div style={this.styles.detailRow}>
                      <span style={this.styles.detailLabel}>Total Amount ({this.state.Order.currency})</span>
                      <span style={{ ...this.styles.detailValue, fontWeight: "bold" }}>
                        {this.state.Order.currency}&nbsp;
                        <NumericFormat
                          displayType={"text"}
                          value={this.state.Order.ccsototalwtax ? this.state.Order.ccsototalwtax : this.state.Order.sototalwtax * this.state.Order.curconversionrate}
                          decimalScale={2}
                          fixedDecimalScale={true}
                          disabled={true}
                          thousandSeparator={true}
                          thousandsGroupStyle={thousandsdisplay}
                        />
                      </span>
                    </div>
                  )}
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Advance Amount</span>
                    <span style={this.styles.detailValue}>
                      <NumericFormat
                        displayType={"text"}
                        value={this.state.Order.advanceamountreq}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        disabled={true}
                        thousandSeparator={true}
                        thousandsGroupStyle={thousandsdisplay}
                      />
                    </span>
                  </div>
                  <div style={this.styles.detailRow}>
                    <span style={this.styles.detailLabel}>Payment Terms</span>
                    <span style={this.styles.detailValue}>
                      {this.state.Order.paymentterms} days
                    </span>
                  </div>
                  {this.state.Order.currency !== currency && (
                    <>
                      <div style={this.styles.detailRow}>
                        <span style={this.styles.detailLabel}>Currency</span>
                        <span style={this.styles.detailValue}>{this.state.Order.currency}</span>
                      </div>
                      <div style={this.styles.detailRow}>
                        <span style={this.styles.detailLabel}>Conversion Rate</span>
                        <span style={this.styles.detailValue}>{this.state.Order.curconversionrate}</span>
                      </div>
                    </>
                  )}
                </div>
              </div>


              {/* Product Detail View */}
              {renderProductDetailView()}

              {/* Products Table */}
              {this.state.saleorderitems.length > 0 && !this.state.activeProductDetail && (
                <div style={{ marginBottom: '24px' }}>
                  <h3 className="UI-label">Products</h3>
                  <TableContainer style={{ border: '1px solid #e2e8f0', borderRadius: '8px' }}>
                    <Table aria-label="products table" size="small">
                      <TableHead style={this.styles.tableHeader}>
                        <TableRow>
                          <TableCell style={this.styles.th}>Item Name</TableCell>
                          {this.state.Order.taxrequired === true && (
                            <TableCell style={this.styles.th}>HSN</TableCell>
                          )}
                          <TableCell style={this.styles.th}>Price</TableCell>
                          {this.state.Order.currency !== currency && (
                            <>
                              <TableCell style={this.styles.th}>Price({this.state.Order.currency})</TableCell>
                              <TableCell style={this.styles.th}>Price Variance (%)</TableCell>
                            </>
                          )}
                          {/* <TableCell style={this.styles.th}>Sales Type</TableCell> */}
                          <TableCell style={this.styles.th}>UOM</TableCell>
                          <TableCell style={this.styles.th}>Total</TableCell>
                          {this.state.Order.currency !== currency && (
                            <TableCell style={this.styles.th}>Total ({this.state.Order.currency})</TableCell>
                          )}
                          {this.state.Order.taxrequired === true && (
                            <>
                              {this.state.Order.taxtype === "GST" && ccountry === "India" ? (
                                this.state.Order.gsttype === "INTRASTATE" ? (
                                  <>
                                    <TableCell style={this.styles.th}>CGST(%)</TableCell>
                                    <TableCell style={this.styles.th}>SGST(%)</TableCell>
                                    {this.state.Order.currency !== currency && (
                                      <>
                                        <TableCell style={this.styles.th}>CGST(%)({this.state.Order.currency})</TableCell>
                                        <TableCell style={this.styles.th}>SGST(%)({this.state.Order.currency})</TableCell>
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <TableCell style={this.styles.th}>IGST(%)</TableCell>
                                    {this.state.Order.currency !== currency && (
                                      <TableCell style={this.styles.th}>IGST(%)({this.state.Order.currency})</TableCell>
                                    )}
                                  </>
                                )
                              ) : this.state.Order.taxtype === "GST" ? (
                                <>
                                  <TableCell style={this.styles.th}>GST(%)</TableCell>
                                  {this.state.Order.currency !== currency && (
                                    <TableCell style={this.styles.th}>GST(%)({this.state.Order.currency})</TableCell>
                                  )}
                                </>
                              ) : (
                                <>
                                  <TableCell style={this.styles.th}>VAT(%)</TableCell>
                                  {this.state.Order.currency !== currency && (
                                    <TableCell style={this.styles.th}>VAT(%)({this.state.Order.currency})</TableCell>
                                  )}
                                </>
                              )}
                              <TableCell style={this.styles.th}>Total Price</TableCell>
                              {this.state.Order.currency !== currency && (
                                <TableCell style={this.styles.th}>Total Price({this.state.Order.currency})</TableCell>
                              )}
                            </>
                          )}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.saleorderitems.map((data, index) => {
                          const itemId = `product-${index}`;
                          const isHovered = this.state.hovered === itemId;

                          return (
                            <TableRow
                              key={index}
                              style={{
                                ...this.styles.tableRow,
                                ...(isHovered && this.styles.tableRowHovered)
                              }}
                              onMouseEnter={() => this.setState({ hovered: itemId })}
                              onMouseLeave={() => this.setState({ hovered: null })}
                              onClick={() => this.handleItemDetail(data, 'product')}
                            >
                              <TableCell style={{
                                ...this.styles.td,
                                ...this.styles.itemName,
                                color: isHovered ? '#5f8f3f' : this.styles.itemName.color,
                                transform: isHovered ? 'scale(1.009)' : 'scale(1)',
                                transition: 'color 0.03s ease, transform 0.03s ease',
                                borderTopLeftRadius: isHovered ? '6px' : '0',
                                borderBottomLeftRadius: isHovered ? '6px' : '0',
                              }}>

                                <div style={{
                                  fontWeight: 'bold',
                                  wordBreak: "break-word",
                                  overflowWrap: "anywhere",
                                  whiteSpace: "pre-wrap",
                                  maxWidth: "300px"
                                }}>
                                  <Tooltip
                                    title="Details"
                                    placement="right"
                                    arrow
                                    open={isHovered}
                                  >

                                    {data.name}
                                  </Tooltip>
                                </div>
                                {data.description && (
                                  <div style={{
                                    fontSize: '0.75rem',
                                    color: '#666',
                                    marginTop: '4px',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 1,
                                    WebkitBoxOrient: 'vertical',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',

                                    wordBreak: "break-word",
                                    overflowWrap: "anywhere",
                                    whiteSpace: "pre-wrap",
                                    maxWidth: "300px"
                                  }}>


                                    {data.description}

                                  </div>
                                )}
                              </TableCell>
                              {this.state.Order.taxrequired === true && (
                                <TableCell style={this.styles.td}>{data.hsn}</TableCell>
                              )}
                              <TableCell style={this.styles.td}>
                                <NumericFormat
                                  displayType={"text"}
                                  value={data.price}
                                  decimalScale={2}
                                  fixedDecimalScale={true}
                                  disabled={true}
                                  thousandSeparator={true}
                                  thousandsGroupStyle={thousandsdisplay}
                                />
                              </TableCell>
                              {this.state.Order.currency !== currency && (
                                <>
                                  <TableCell style={this.styles.td}>
                                    <NumericFormat
                                      displayType={"text"}
                                      value={data.ccprice ? data.ccprice : data.price * this.state.Order.curconversionrate}
                                      decimalScale={2}
                                      fixedDecimalScale={true}
                                      disabled={true}
                                      thousandSeparator={true}
                                      thousandsGroupStyle={thousandsdisplay}
                                    />
                                  </TableCell>
                                  <TableCell style={this.styles.td}>{data.pricevariance}</TableCell>
                                </>
                              )}
                              {/* <TableCell style={this.styles.td}>{data.salesenum}</TableCell> */}
                              <TableCell style={this.styles.td}>
                                {data.quantity} {data.uom}
                              </TableCell>
                              <TableCell style={this.styles.td}>
                                <NumericFormat
                                  displayType={"text"}
                                  value={data.totalprice}
                                  decimalScale={2}
                                  fixedDecimalScale={true}
                                  disabled={true}
                                  thousandSeparator={true}
                                  thousandsGroupStyle={thousandsdisplay}
                                />
                              </TableCell>
                              {this.state.Order.currency !== currency && (
                                <TableCell style={this.styles.td}>
                                  <NumericFormat
                                    displayType={"text"}
                                    value={data.cctotalprice ? data.cctotalprice : data.totalprice * this.state.Order.curconversionrate}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    disabled={true}
                                    thousandSeparator={true}
                                    thousandsGroupStyle={thousandsdisplay}
                                  />
                                </TableCell>
                              )}
                              {this.state.Order.taxrequired === true && (
                                <>
                                  {this.state.Order.taxtype === "GST" && ccountry === "India" && this.state.Order.gsttype === "INTRASTATE" ? (
                                    <>
                                      <TableCell style={this.styles.td}>
                                        <NumericFormat
                                          displayType={"text"}
                                          value={data.taxamount * 0.5}
                                          decimalScale={2}
                                          fixedDecimalScale={true}
                                          disabled={true}
                                          thousandSeparator={true}
                                          thousandsGroupStyle={thousandsdisplay}
                                        />
                                        &nbsp;({data.tax / 2}%)
                                      </TableCell>
                                      <TableCell style={this.styles.td}>
                                        <NumericFormat
                                          displayType={"text"}
                                          value={data.taxamount / 2}
                                          decimalScale={2}
                                          fixedDecimalScale={true}
                                          disabled={true}
                                          thousandSeparator={true}
                                          thousandsGroupStyle={thousandsdisplay}
                                        />
                                        &nbsp;({data.tax / 2}%)
                                      </TableCell>
                                      {this.state.Order.currency !== currency && (
                                        <>
                                          <TableCell style={this.styles.td}>
                                            <NumericFormat
                                              displayType={"text"}
                                              value={data.cctaxamount ? (data.cctaxamount / 2) : ((data.taxamount / 2) * this.state.Order.curconversionrate)}
                                              decimalScale={2}
                                              fixedDecimalScale={true}
                                              disabled={true}
                                              thousandSeparator={true}
                                              thousandsGroupStyle={thousandsdisplay}
                                            />
                                            &nbsp;({data.tax / 2}%)
                                          </TableCell>
                                          <TableCell style={this.styles.td}>
                                            <NumericFormat
                                              displayType={"text"}
                                              value={data.cctaxamount ? (data.cctaxamount / 2) : ((data.taxamount / 2) * this.state.Order.curconversionrate)}
                                              decimalScale={2}
                                              fixedDecimalScale={true}
                                              disabled={true}
                                              thousandSeparator={true}
                                              thousandsGroupStyle={thousandsdisplay}
                                            />
                                            &nbsp;({data.tax / 2}%)
                                          </TableCell>
                                        </>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      <TableCell style={{ ...this.styles.td, fontWeight: "bold" }}>
                                        <NumericFormat
                                          displayType={"text"}
                                          value={data.taxamount}
                                          decimalScale={2}
                                          fixedDecimalScale={true}
                                          disabled={true}
                                          thousandSeparator={true}
                                          thousandsGroupStyle={thousandsdisplay}
                                        />
                                        &nbsp;({data.tax}%)
                                      </TableCell>

                                      {this.state.Order.currency !== currency && (
                                        <TableCell style={{ ...this.styles.td, fontWeight: "bold" }}>
                                          <NumericFormat
                                            displayType={"text"}
                                            value={data.cctaxamount ? data.cctaxamount : data.taxamount * this.state.Order.curconversionrate}
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            disabled={true}
                                            thousandSeparator={true}
                                            thousandsGroupStyle={thousandsdisplay}
                                          />
                                          &nbsp;({data.tax}%)
                                        </TableCell>
                                      )}
                                    </>
                                  )}
                                  <TableCell style={{ ...this.styles.td, fontWeight: "bold" }}>
                                    <NumericFormat
                                      displayType={"text"}
                                      value={data.totalpricewtax}
                                      decimalScale={2}
                                      fixedDecimalScale={true}
                                      disabled={true}
                                      thousandSeparator={true}
                                      thousandsGroupStyle={thousandsdisplay}
                                    />
                                  </TableCell>

                                  {this.state.Order.currency !== currency && (
                                    <TableCell style={{ ...this.styles.td, fontWeight: "bold" }}>
                                      <NumericFormat
                                        displayType={"text"}
                                        value={data.cctotalpricewtax ? data.cctotalpricewtax : data.totalpricewtax * this.state.Order.curconversionrate}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                        disabled={true}
                                        thousandSeparator={true}
                                        thousandsGroupStyle={thousandsdisplay}
                                      />
                                    </TableCell>
                                  )}
                                </>
                              )}
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              )}

              {/* Service Detail View */}
              {renderServiceDetailView()}

              {/* Services Table */}
              {this.state.serviceList.length > 0 && !this.state.activeServiceDetail && (
                <div style={{ marginBottom: '24px' }}>
                  <h3 className="UI-label">Services</h3>
                  <TableContainer style={{ border: '1px solid #e2e8f0', borderRadius: '8px' }}>
                    <Table aria-label="services table" size="small">
                      <TableHead style={this.styles.tableHeader}>
                        <TableRow>
                          <TableCell style={this.styles.th}>Sl. No.</TableCell>
                          <TableCell style={this.styles.th}>Service</TableCell>
                          <TableCell style={this.styles.th}>Service Description</TableCell>
                          {this.state.Order.taxrequired === true && (
                            <TableCell style={this.styles.th}>HSN/SAC Code</TableCell>
                          )}
                          <TableCell style={this.styles.th}>Price ({currency})</TableCell>
                          {this.state.Order.currency !== currency && (
                            <TableCell style={this.styles.th}>Price ({this.state.Order.currency})</TableCell>
                          )}
                          <TableCell style={this.styles.th}>Discount</TableCell>
                          {this.state.Order.taxrequired === true && (
                            <>
                              {this.state.Order.taxtype === "GST" && ccountry === "India" ? (
                                this.state.Order.gsttype === "INTRASTATE" ? (
                                  <>
                                    <TableCell style={this.styles.th}>CGST(%)</TableCell>
                                    <TableCell style={this.styles.th}>SGST(%)</TableCell>
                                  </>
                                ) : (
                                  <TableCell style={this.styles.th}>IGST(%)</TableCell>
                                )
                              ) : this.state.Order.taxtype === "GST" ? (
                                <TableCell style={this.styles.th}>GST(%)</TableCell>
                              ) : (
                                <TableCell style={this.styles.th}>VAT(%)</TableCell>
                              )}
                              <TableCell style={this.styles.th}>Total Price ({currency})</TableCell>
                              {this.state.Order.currency !== currency && (
                                <TableCell style={this.styles.th}>Total Price ({this.state.Order.currency})</TableCell>
                              )}
                            </>
                          )}
                          {this.state.serviceList
                            .map((e) => e.contracttype)
                            .toLocaleString() ===
                            "Recurring" ? (
                            <>
                              <TableCell style={this.styles.th}>Recurring Type</TableCell>
                              <TableCell style={this.styles.th}>Recurring End Date</TableCell>
                            </>
                          ) : (
                            ""
                          )}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.serviceList.map((data, index) => {
                          const itemId = `service-${index}`;
                          const isHovered = this.state.hovered === itemId;

                          return (
                            <TableRow
                              key={index}
                              style={{
                                ...this.styles.tableRow,
                                ...(isHovered && this.styles.tableRowHovered)
                              }}
                              onMouseEnter={() => this.setState({ hovered: itemId })}
                              onMouseLeave={() => this.setState({ hovered: null })}
                              onClick={() => this.handleItemDetail(data, 'service')}
                            >
                              <TableCell style={{
                                ...this.styles.td,
                                ...this.styles.itemName,
                                // color: isHovered ? '#5f8f3f' : this.styles.itemName.color,
                                // transform: isHovered ? 'scale(1.009)' : 'scale(1)',
                                // transition: 'color 0.03s ease, transform 0.03s ease',
                                // borderTopLeftRadius: isHovered ? '6px' : '0',
                                // borderBottomLeftRadius: isHovered ? '6px' : '0',
                              }}>
                                {index + 1}
                              </TableCell>
                              <TableCell style={{
                                ...this.styles.td,
                                ...this.styles.itemName,
                                fontWeight: "bold",
                                color: isHovered ? '#5f8f3f' : this.styles.itemName.color,
                                transform: isHovered ? 'scale(1.009)' : 'scale(1)',
                                transition: 'color 0.03s ease, transform 0.03s ease',
                                borderTopLeftRadius: isHovered ? '6px' : '0',
                                borderBottomLeftRadius: isHovered ? '6px' : '0',

                                wordBreak: "break-word",
                                overflowWrap: "anywhere",
                                whiteSpace: "pre-wrap",
                                maxWidth: "300px"
                              }}>
                                <Tooltip
                                  title="Details"
                                  placement="right"
                                  arrow
                                  open={isHovered}
                                >
                                  {data.service}
                                </Tooltip>
                              </TableCell>
                              <TableCell style={{
                                ...this.styles.td, fontSize: "11px",

                                display: '-webkit-box',
                                WebkitLineClamp: 1,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',

                                wordBreak: "break-word",
                                overflowWrap: "anywhere",
                                whiteSpace: "pre-wrap",
                                maxWidth: "300px"
                              }}>{data.description}</TableCell>
                              {this.state.Order.taxrequired === true && (
                                <TableCell style={this.styles.td}>{data.servicecode}</TableCell>
                              )}
                              <TableCell style={{ ...this.styles.td, fontWeight: "bold" }}>
                                <NumericFormat
                                  displayType={"text"}
                                  value={data.servicecost + data.markup1}
                                  decimalScale={2}
                                  fixedDecimalScale={true}
                                  disabled={true}
                                  thousandSeparator={true}
                                  thousandsGroupStyle={thousandsdisplay}
                                />
                              </TableCell>
                              {this.state.Order.currency !== currency && (
                                <TableCell style={{ ...this.styles.td, fontWeight: "bold" }}>
                                  <NumericFormat
                                    displayType={"text"}
                                    value={data.ccservicecost ? (data.ccservicecost + data.ccmarkup1) : (data.servicecost + data.markup1) * this.state.Order.curconversionrate}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    disabled={true}
                                    thousandSeparator={true}
                                    thousandsGroupStyle={thousandsdisplay}
                                  />
                                </TableCell>
                              )}
                              <TableCell style={{ ...this.styles.td, fontWeight: "" }}>
                                {data.servicediscount ? data.servicediscount : 0}%
                              </TableCell>
                              {this.state.Order.taxrequired === true && (
                                <>
                                  {this.state.Order.taxtype === "GST" && ccountry === "India" && this.state.Order.gsttype === "INTRASTATE" ? (
                                    <>
                                      <TableCell style={this.styles.td}>{data.servicetax / 2}%</TableCell>
                                      <TableCell style={{ ...this.styles.td, fontWeight: "" }}>{data.servicetax / 2}%</TableCell>
                                    </>
                                  ) : (
                                    <TableCell style={{ ...this.styles.td, fontWeight: "bold" }}>{data.servicetax}%</TableCell>
                                  )}
                                  <TableCell style={{ ...this.styles.td, fontWeight: "bold" }}>
                                    <NumericFormat
                                      displayType={"text"}
                                      value={data.servicetotalwtax}
                                      decimalScale={2}
                                      fixedDecimalScale={true}
                                      disabled={true}
                                      thousandSeparator={true}
                                      thousandsGroupStyle={thousandsdisplay}
                                    />
                                  </TableCell>
                                  {this.state.Order.currency !== currency && (
                                    <TableCell style={{ ...this.styles.td, fontWeight: "bold" }}>
                                      <NumericFormat
                                        displayType={"text"}
                                        value={data.ccservicetotalwtax ? data.ccservicetotalwtax : data.servicetotalwtax * this.state.Order.curconversionrate}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                        disabled={true}
                                        thousandSeparator={true}
                                        thousandsGroupStyle={thousandsdisplay}
                                      />
                                    </TableCell>
                                  )}
                                </>
                              )}
                              {data.contracttype === "Recurring" ? (
                                <>
                                  <TableCell style={this.styles.td}>{data.recurringtype}</TableCell>
                                  <TableCell style={this.styles.td}>
                                    {moment(data.recurrencetill).format("DD-MM-YYYY")}
                                  </TableCell>
                                </>
                              ) : (
                                ""
                              )}
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              )}

              {/* Milestone Detail View */}
              {renderMilestoneDetailView()}

              {/* Milestones Table */}
              {this.state.milestones.length > 0 && !this.state.activeMilestoneDetail && (
                <div style={{ marginBottom: '24px' }}>
                  <h3 style={{ ...this.styles.sectionTitle, border: 'none', marginBottom: '16px' }}>Milestones</h3>
                  <TableContainer style={{ border: '1px solid #e2e8f0', borderRadius: '8px' }}>
                    <Table aria-label="milestones table" size="small">
                      <TableHead style={this.styles.tableHeader}>
                        <TableRow>
                          <TableCell style={this.styles.th}>Name</TableCell>
                          <TableCell style={this.styles.th}>Expected Date</TableCell>
                          <TableCell style={this.styles.th}>Percentage</TableCell>
                          <TableCell style={this.styles.th}>Amount</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.milestones.map((data, index) => {
                          const itemId = `milestone-${index}`;
                          const isHovered = this.state.hovered === itemId;

                          return (
                            <TableRow
                              key={index}
                              style={{
                                ...this.styles.tableRow,
                                ...(isHovered && this.styles.tableRowHovered)
                              }}
                              onMouseEnter={() => this.setState({ hovered: itemId })}
                              onMouseLeave={() => this.setState({ hovered: null })}
                              onClick={() => this.handleItemDetail(data, 'milestone')}
                            >
                              <TableCell style={{
                                ...this.styles.td,
                                ...this.styles.itemName,
                                fontWeight: "bold",
                                color: isHovered ? '#5f8f3f' : this.styles.itemName.color,
                                transform: isHovered ? 'scale(1.009)' : 'scale(1)',
                                transition: 'color 0.03s ease, transform 0.03s ease',
                                borderTopLeftRadius: isHovered ? '6px' : '0',
                                borderBottomLeftRadius: isHovered ? '6px' : '0',
                              }}>
                                <Tooltip
                                  title="Details"
                                  placement="right"
                                  arrow
                                  open={isHovered}
                                >
                                  <span>{data.name}</span>
                                </Tooltip>
                              </TableCell>
                              <TableCell style={this.styles.td}>
                                {moment(data.expecteddate).format("DD-MM-YYYY")}
                              </TableCell>
                              <TableCell style={this.styles.td}>{data.percentage} %</TableCell>
                              <TableCell style={{ ...this.styles.td, fontWeight: "bold" }}>
                                <NumericFormat
                                  displayType={"text"}
                                  value={data.amount}
                                  decimalScale={2}
                                  fixedDecimalScale={true}
                                  disabled={true}
                                  thousandSeparator={true}
                                  thousandsGroupStyle={thousandsdisplay}
                                />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              )}

              {/* Modals (unchanged) */}
              <Modal
                show={this.state.show}
                onHide={this.handleClose}
                backdrop="static"
                keyboard={false}
                centered
                size="lg"
              >
                <Modal.Header closeButton>
                  <b>Mail</b>
                </Modal.Header>

                <div className="form-row mt-5 ml-5">
                  <fieldset className="form-group col-md-4">
                    <label htmlFor="btn-upload">
                      <input
                        className="btn-choose"
                        id="btn-upload"
                        name="btn-upload"
                        style={{ display: "none" }}
                        type="file"
                        onChange={this.selectFile}
                      />
                      <Button
                        className="btn-close"
                        variant="outlined"
                        type="upload"
                        component="span"
                      >
                        <span className="text-blue">Select File to Upload</span>
                      </Button>
                    </label>
                  </fieldset>

                  <fieldset className="form-group col-md-3">
                    <ul className="list-group">
                      {selectedFiles && selectedFiles.length > 0
                        ? selectedFiles[0].name
                        : null}
                    </ul>
                  </fieldset>

                  <fieldset className="form-group col-md-3">
                    <Button
                      className="btn-upload"
                      color="primary"
                      variant="contained"
                      component="span"
                      disabled={!selectedFiles}
                      onClick={this.upload}
                    >
                      Upload
                    </Button>
                  </fieldset>

                  <div className="form-group col-md-9">
                    <Typography
                      variant="subtitle2"
                      className={`upload-message ${isError ? "error" : ""}`}
                    >
                      <span className="text-green">{message}</span>
                    </Typography>
                  </div>
                </div>

                <Modal.Footer>
                  <button
                    className="btn btn-sm hovbuttonColour"
                    onClick={this.handleClose} // ✅ Cancel action
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-sm hovbuttonColour"
                    onClick={this.handleSendMail}
                  >
                    Send <i className="fa fa-paper-plane" aria-hidden="true" />
                  </button>
                </Modal.Footer>
              </Modal>


              <Modal
                show={this.state.showModal}
                onHide={this.handleModalClose}
                backdrop="static"
                keyboard={false}
                centered
                size="lg"
              >
                <Modal.Header closeButton>PO File</Modal.Header>
                <div className="form-row mt-5 ml-5">
                  <fieldset className="form-group col-md-4">
                    <label htmlFor="btn-upload">
                      <input
                        className="btn-choose"
                        id="btn-upload"
                        name="btn-upload"
                        style={{ display: "none" }}
                        type="file"
                        onChange={this.selectFile}
                      />
                      <Button
                        className="btn-close"
                        variant="outlined"
                        type="upload"
                        component="span"
                      >
                        <span className="text-blue">Select File to Upload</span>
                      </Button>
                    </label>
                  </fieldset>
                  <fieldset className="form-group col-md-3">
                    <ul className="list-group">
                      {selectedFiles && selectedFiles.length > 0
                        ? selectedFiles[0].name
                        : null}
                    </ul>
                  </fieldset>

                  <fieldset className="form-group col-md-3">
                    <Button
                      className="btn-upload"
                      color="primary"
                      variant="contained"
                      component="span"
                      disabled={!selectedFiles}
                      onClick={this.upload}
                    >
                      Upload
                    </Button>
                  </fieldset>

                  <div className="form-group col-md-9">
                    <Typography
                      variant="subtitle2"
                      className={`upload-message ${isError ? "error" : ""}`}
                    >
                      <span className="text-green">{message}</span>
                    </Typography>
                  </div>
                  {this.state.Order.potype !== 1 && (
                    <>
                      <div className="form-group col-md-4">
                        <TextField
                          className="form-control"
                          type="text"
                          name="poid"
                          onChange={(e) => this.setState({ poid: e.target.value })}
                          label="PO Id."
                        />
                      </div>
                      <div className="form-group col-md-4">
                        <TextField
                          id="amount"
                          className="fAmountorm-control"
                          type="number"
                          name="amount"
                          value={this.state.amount}
                          label="PO Amount"
                          onChange={(e) => this.setState({ amount: e.target.value })}
                          onFocus={this.onfocus}
                        />
                      </div>
                    </>
                  )}

                  {this.state.amount !== "" && this.state.fileInfos.length > 0 && this.state.poid !== "" && (
                    <div className="form-group col-md-9">
                      <button
                        className={`btn btn-sm hovbuttonColour float-center`}
                        onClick={this.handleFinalSubmit}
                      >
                        Submit
                      </button>
                    </div>
                  )}
                </div>

                <Modal.Body></Modal.Body>
              </Modal>

              <Modal
                show={this.state.showCancelModal}
                onHide={this.handleCancelModalClose}
                backdrop="static"
                keyboard={false}
                centered
                size="lg"
              >
                <Modal.Header closeButton>Order Cancellation</Modal.Header>
                <div className="form-row mt-3 ml-3">
                  <fieldset className="form-group col-md-8">
                    <TextField
                      name="desc"
                      className="form-control"
                      multiline
                      rows={2}
                      label="Reason For Cancellation"
                      variant="outlined"
                      value={this.state.desc}
                      onChange={(e) => this.setState({ desc: e.target.value })}
                    />
                  </fieldset>
                  <fieldset className="form-group col-md-12" />
                  <button
                    className="btn btn-sm hovbuttonColour ml-2"
                    onClick={this.handleCancel}
                    disabled={this.state.desc === ""}
                  >
                    Submit
                  </button>
                </div>
                <Modal.Body> </Modal.Body>
              </Modal>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(ViewQuotation);